var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg403ErrorOption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706,242.24s0-.1,0-.28,0-.47,0-.8c0-.72,0-1.73,0-3,0-2.67-.05-6.52-.09-11.38l.16.16-57.55.1.26-.26h0v7.87q0,3.88,0,7.62l-.25-.26,41,.12,12.1.07,3.27,0,.85,0a1.71,1.71,0,0,1,.3,0h-.27l-.82,0-3.21,0-12,.08-41.21.11h-.25v-.25q0-3.74,0-7.62v-7.87h0l.26-.26,57.55.1h.16v.16c0,4.9-.07,8.78-.09,11.47,0,1.29,0,2.3,0,3,0,.32,0,.57,0,.77A1.15,1.15,0,0,1,706,242.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.08,
    y: 35.17,
    width: 57.55,
    height: 15.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.71,66.57s0-.1,0-.28,0-.46,0-.79c0-.72,0-1.74,0-3,0-2.67-.05-6.52-.09-11.38l.16.16-57.55.1.26-.26h0V59q0,3.88,0,7.62l-.25-.25,41,.11,12.1.07,3.27,0h.85l.3,0a1.15,1.15,0,0,1-.27,0h-.82l-3.21,0-12,.07-41.21.11h-.26V51.08h0l.26-.26,57.55.1h.16v.16c0,4.9-.07,8.78-.09,11.47,0,1.3,0,2.3,0,3,0,.31,0,.57,0,.76A1.15,1.15,0,0,1,453.71,66.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.09,306.13a1.73,1.73,0,0,1,0-.28c0-.2,0-.46,0-.79,0-.73,0-1.74,0-3.05,0-2.67-.05-6.52-.09-11.38l.16.16-57.55.1.26-.26h0v7.87q0,3.89,0,7.62l-.25-.26,41,.12,12.1.07,3.26,0h.86l.3,0h-.27l-.82,0-3.21,0-12,.08-41.21.11h-.26V290.64h0l.26-.26,57.55.1h.16v.16c0,4.9-.07,8.78-.09,11.47,0,1.3,0,2.3,0,3,0,.32,0,.57,0,.77S141.09,306.13,141.09,306.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5,321.63a2,2,0,0,1,0-.3c0-.22,0-.49,0-.82,0-.76,0-1.8-.05-3.11,0-2.72-.06-6.56-.11-11.27l.2.2-28.77.06c-.24.23.31-.32.25-.26h0v8c0,2.59,0,5.1,0,7.49l-.25-.25,20.62.12,6,.07,1.61,0,.57,0a3.2,3.2,0,0,1-.52,0l-1.56,0-5.91.06-20.79.12h-.24v-.24c0-2.39,0-4.9,0-7.49,0-1.3,0-2.62,0-3.95v-4.05h0c0,.05.5-.5.27-.26l28.77.06h.2v.2c0,4.76-.08,8.64-.11,11.39,0,1.29,0,2.32-.05,3.07,0,.31,0,.57,0,.78A1.1,1.1,0,0,1,147.5,321.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.82,78.68a1.58,1.58,0,0,1,0-.28c0-.2,0-.46,0-.79,0-.72,0-1.74,0-3,0-2.67,0-6.52-.09-11.38l.16.16-57.55.1c.11-.12-.27.26.25-.26h0V78.68l-.26-.25,41,.11,12.09.07,3.27,0h.86l.3,0-.27,0h-.82l-3.22,0-12,.07-41.21.11H627V71.06c0-1.29,0-2.6,0-3.91v-4h0c.52-.52.15-.14.27-.26l57.55.1H685v.16c0,4.9-.07,8.78-.09,11.47,0,1.3,0,2.3,0,3,0,.31,0,.57,0,.76A2.06,2.06,0,0,1,684.82,78.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.23,94.18a1.06,1.06,0,0,1,0-.29c0-.22,0-.5,0-.83,0-.76,0-1.8-.05-3.11,0-2.72-.07-6.56-.11-11.27l.2.2-28.78.06.26-.26h0v8c0,2.59,0,5.1,0,7.49l-.24-.24,20.62.11,6,.07,1.6,0,.58,0a3.2,3.2,0,0,1-.52,0l-1.56,0-5.92.07-20.78.11h-.24v-.25c0-2.39,0-4.9,0-7.49v-8h0l.26-.26,28.78.06h.2v.2c0,4.76-.07,8.64-.1,11.39,0,1.29,0,2.32-.05,3.07,0,.32,0,.58,0,.79S691.23,94.19,691.23,94.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.54,
    y: 150.32,
    width: 57.55,
    height: 15.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18,181.72a1.73,1.73,0,0,1,0-.28c0-.21,0-.47,0-.8,0-.72,0-1.74,0-3,0-2.67-.06-6.52-.09-11.37l.16.15-57.55.11c.11-.12-.27.26.25-.26h0v15.48l-.26-.26,41,.12,12.09.07,3.27,0,.86,0a1.11,1.11,0,0,1,.3,0h-.27l-.82,0-3.22,0-12,.07L67.62,182h-.25v-.25c0-2.49,0-5,0-7.62v-7.86h0l.27-.27,57.55.11h.16v.16c0,4.89-.07,8.78-.09,11.47,0,1.29,0,2.3,0,3,0,.32,0,.57,0,.77A2.28,2.28,0,0,1,125.18,181.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.01,
    y: 272.44,
    width: 57.55,
    height: 15.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.64,303.84s0-.1,0-.28,0-.47,0-.8c0-.72,0-1.74,0-3,0-2.67-.05-6.53-.09-11.38l.16.16-57.55.1.26-.26h0v7.86c0,2.59,0,5.13,0,7.62l-.25-.26,41,.12,12.1.07,3.27,0,.85,0,.3,0h-.27l-.82,0-3.21,0-12,.08-41.21.11h-.26V288.36h0l.26-.26,57.55.1h.16v.16c0,4.9-.07,8.78-.09,11.47,0,1.29,0,2.3,0,3,0,.32,0,.57,0,.77A1.15,1.15,0,0,1,565.64,303.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.11,362.47s0-.1,0-.28,0-.47,0-.8c0-.72,0-1.74,0-3.05,0-2.66-.05-6.52-.09-11.37l.16.15-57.55.11.26-.26h0v7.86c0,2.58,0,5.13,0,7.62l-.25-.26,41,.12,12.1.07,3.27,0,.85,0a1,1,0,0,1,.3,0h-.27l-.82,0-3.21,0-12,.07-41.21.12h-.26V347h0l.26-.26,57.55.1h.16V347c0,4.89-.07,8.78-.09,11.47,0,1.29,0,2.3,0,3,0,.32,0,.57,0,.77A1.15,1.15,0,0,1,281.11,362.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.57,89s0-.1,0-.28,0-.46,0-.79c0-.72,0-1.74,0-3,0-2.67-.05-6.52-.09-11.38l.16.16L177,73.8l.26-.26h0v7.87q0,3.89,0,7.62l-.25-.25,41,.11,12.1.08,3.27,0,.85,0h.3a1.15,1.15,0,0,1-.27,0l-.82,0-3.21,0-12,.07L177,89.3h-.26V73.55h0l.26-.26,57.55.1h.16v.16c0,4.9-.07,8.78-.09,11.48,0,1.29,0,2.3,0,3,0,.32,0,.57,0,.76A1,1,0,0,1,234.57,89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.1,464.82c-16-12.61-18.51-34.44-16.73-53.83.3-3.23.14-6.67,1.85-9.43s5.42-4.49,8.24-2.95c2.35,1.27,3.23,4.13,4.45,6.53a19,19,0,0,0,7.18,7.7c2,1.19,4.52,2,6.62,1,2.89-1.38,3.44-5.23,3.61-8.45l.93-18c.17-3.23.35-6.52,1.53-9.52s3.56-5.72,6.68-6.4,6.81,1.31,7.27,4.5a28.49,28.49,0,0,1-.14,4c0,1.35.55,2.86,1.8,3.31S647,382.86,648,382c3.52-3.06,6-7.12,8.37-11.17s4.65-8.2,7.88-11.58,7.56-6,12.2-5.94,9.39,3.14,10.29,7.74-2,9.08-5.11,12.59A72.25,72.25,0,0,1,665.83,387a5.92,5.92,0,0,0-2.66,2.55c-.83,2.11,1.09,4.36,3.17,5.19,2.36.94,5,.84,7.48,1.28s5.15,1.71,6,4.14c1.13,3.38-1.83,6.67-4.68,8.78a61.82,61.82,0,0,1-18.86,9.47c-2.42.73-5,1.35-7,2.91s-3.33,4.38-2.31,6.72,3.95,3.24,6.46,2.93,4.82-1.54,7.24-2.3c4.53-1.41,10.23-.78,12.85,3.22,1.72,2.63,1.68,6.14.56,9.09a23.59,23.59,0,0,1-5.35,7.68,62.09,62.09,0,0,1-27.56,17.08c-10.48,3-20.07,3.38-30.07-.95",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.82,452.93a288.85,288.85,0,0,1,13.28-30.45l3.89-7.8c1.28-2.55,2.55-5.09,4-7.5a144.29,144.29,0,0,1,8.82-13.35c3-4.11,6-7.9,8.86-11.43s5.56-6.75,8.16-9.59A114.91,114.91,0,0,1,677,360.33c1.67-1.34,3-2.34,3.92-3l1-.75a1.9,1.9,0,0,1,.37-.24,2,2,0,0,1-.33.29l-1,.8c-.89.69-2.2,1.72-3.85,3.09a120.92,120.92,0,0,0-13.08,12.59c-2.58,2.85-5.27,6.08-8.09,9.61s-5.81,7.34-8.8,11.45a146.2,146.2,0,0,0-8.76,13.32c-1.38,2.39-2.64,4.91-3.93,7.47s-2.57,5.17-3.88,7.8a295.11,295.11,0,0,0-13.29,30.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.11,407.17a6.4,6.4,0,0,1-.23-1.39c-.12-.9-.25-2.21-.38-3.83-.27-3.24-.49-7.72-.72-12.67s-.5-9.41-.82-12.63c-.16-1.62-.29-2.92-.4-3.82a6.74,6.74,0,0,1-.1-1.41,6.82,6.82,0,0,1,.33,1.37c.17.89.38,2.19.58,3.81.43,3.22.78,7.7,1,12.65s.39,9.3.54,12.67c.07,1.52.13,2.81.19,3.84A6.41,6.41,0,0,1,638.11,407.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680,401.83a9.55,9.55,0,0,1-1.66.1c-1.07,0-2.62.07-4.53.18-3.82.19-9.09.64-14.88,1.39s-11,1.66-14.76,2.43c-1.88.37-3.39.71-4.44.94a8.94,8.94,0,0,1-1.64.3,8.81,8.81,0,0,1,1.59-.53c1-.3,2.53-.7,4.4-1.13,3.74-.87,9-1.85,14.77-2.61a146,146,0,0,1,14.94-1.21c1.92-.06,3.48,0,4.55,0A8.53,8.53,0,0,1,680,401.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.38,452.2a2.17,2.17,0,0,1-.26-.52l-.62-1.55c-.53-1.34-1.26-3.3-2.12-5.73-1.72-4.87-3.89-11.66-6.19-19.19s-4.4-14.35-6-19.24c-.79-2.38-1.45-4.34-1.94-5.79-.2-.63-.37-1.15-.51-1.58a2,2,0,0,1-.15-.57,2.42,2.42,0,0,1,.26.53c.17.41.37.92.62,1.54.54,1.34,1.26,3.3,2.12,5.73,1.72,4.87,3.89,11.66,6.19,19.2s4.4,14.34,6,19.23c.8,2.38,1.45,4.34,1.94,5.79.2.63.38,1.16.52,1.58A2.18,2.18,0,0,1,617.38,452.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.5,437.64a2.18,2.18,0,0,1-.56.19l-1.63.44-6,1.57c-5.07,1.33-12.06,3.24-19.78,5.37s-14.74,4-19.84,5.19c-2.55.62-4.62,1.09-6.06,1.39l-1.66.33a2.32,2.32,0,0,1-.58.08,2.09,2.09,0,0,1,.56-.2l1.63-.44,6-1.57c5.07-1.33,12.06-3.24,19.79-5.36s14.73-4,19.83-5.2c2.55-.61,4.62-1.09,6.06-1.38l1.66-.34A2,2,0,0,1,673.5,437.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,333.17s-8.06,2.78.15,20,14,25.8,14,25.8,1.44,4-1.9,4.51-10.62-.84-12.21,3.19,1.31,8.23,7.42,11.88,19.21,12.16,20.4,12.93,2.29,2.63.07,3.35-18.71,2-17.64,9.78S150,439.8,152,440.65s2.5,1.72,2.3,2.85-5.78,1-10.46,1.58-10,2-9,6.46,11.94,14,39,17.41l12.66.75,7.18-10.52c14-23.45,13.19-38,10.3-41.48s-7.32-.22-10.64,3.12-6.67,7.81-7.68,7.27-1.41-1.44-.83-3.56,6.27-21.41.79-27-16.63,6.58-18.57,7.88-2.7-.74-2.59-2.12,1.48-17,2.37-24-.5-11.9-4.81-13.17c-4.15-1.22-7.55,5.36-10,7.67s-4.73-1.28-4.73-1.28-3.2-9.83-11.72-26.91-15.83-12.28-15.83-12.28",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.11,472.7c-6.21-12.57-16.87-35.09-26.13-54.37S143.33,381.6,137.19,369l-7.3-14.9-2-4.06c-.22-.45-.38-.81-.51-1.06s-.16-.37-.16-.37.08.12.2.35l.54,1c.48.94,1.17,2.29,2,4,1.77,3.49,4.3,8.57,7.41,14.85,6.21,12.57,14.64,30,23.9,49.28s19.88,41.82,26,54.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06,389a5.53,5.53,0,0,1,.88.27c.55.2,1.35.51,2.33.89,2,.78,4.63,1.93,7.57,3.24l7.49,3.4,2.27,1a3.73,3.73,0,0,1,.82.41,3.79,3.79,0,0,1-.87-.26c-.56-.2-1.36-.51-2.33-.9-1.95-.8-4.62-2-7.55-3.3l-7.51-3.34-2.28-1A4,4,0,0,1,130.06,389Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.31,397.42c-.1,0,2-5.66,4.73-12.55s5-12.46,5.09-12.42-2,5.66-4.72,12.56S152.41,397.46,152.31,397.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.19,427.68a4.33,4.33,0,0,1,.53-.77l1.56-2c1.31-1.7,3.11-4.06,5-6.73s3.53-5.15,4.7-7l1.38-2.13a4.21,4.21,0,0,1,.55-.76,4.2,4.2,0,0,1-.42.84c-.29.52-.72,1.28-1.28,2.2-1.11,1.84-2.71,4.35-4.61,7s-3.74,5-5.11,6.68c-.69.82-1.25,1.49-1.66,1.93A5.31,5.31,0,0,1,165.19,427.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.38,424.48a3.6,3.6,0,0,1,.87,0l2.34.25c2,.23,4.69.57,7.7,1s5.72.78,7.69,1.08l2.32.37a3.09,3.09,0,0,1,.84.2,4.29,4.29,0,0,1-.86,0l-2.34-.25c-2-.23-4.7-.57-7.7-1s-5.72-.79-7.69-1.09l-2.32-.37A3.8,3.8,0,0,1,143.38,424.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,452.63a7.63,7.63,0,0,1,1.11.06l3,.31c2.53.28,6,.69,9.87,1.16s7.35.94,9.87,1.28l3,.44a5.45,5.45,0,0,1,1.09.21,6,6,0,0,1-1.1-.06l-3-.31c-2.54-.28-6-.69-9.88-1.16s-7.35-.93-9.87-1.28l-3-.44A5.68,5.68,0,0,1,151.36,452.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.64,455.82a6.55,6.55,0,0,1,.65-1l1.88-2.63c1.59-2.21,3.77-5.28,6.08-8.74s4.32-6.64,5.77-8.95l1.7-2.74a6.38,6.38,0,0,1,.67-1,8.06,8.06,0,0,1-.53,1.06c-.37.67-.91,1.63-1.61,2.8-1.38,2.35-3.36,5.57-5.68,9s-4.53,6.51-6.17,8.69c-.83,1.08-1.51,2-2,2.55A8.91,8.91,0,0,1,178.64,455.82Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.75,425.36c-4.72-5.57-5.34-14.51-4.65-21.77s2.38-14.58,1.23-21.78c-.68-4.27-2.33-8.35-2.89-12.64s.23-9.13,3.55-11.9c3.82-3.18,9.83-2.43,13.8.56s6.28,7.68,8,12.35c3.69,10.27,5.05,21.66,2,32.15s-10.15,19.86-20.6,23",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,438c.77-2.69,2.43-5.29,5-6.39s5.77-.5,8.5.49,5.42,2.33,8.32,2.51,6.19-1.2,7.06-4c.81-2.61-.76-5.39-2.73-7.29a17.21,17.21,0,0,0-28.19,6.77",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.81,438c.77-2.69,2.43-5.29,5-6.39s5.77-.5,8.5.49,5.42,2.33,8.32,2.51,6.19-1.2,7.06-4c.81-2.61-.76-5.39-2.73-7.29a17.21,17.21,0,0,0-28.19,6.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,449.67c-4.26-4-4-11.09-1.92-16.57s6.76-9.68,11.94-12.46a37.82,37.82,0,0,1,33-1.06A15.63,15.63,0,0,0,149.14,427c-2.34,3.88-2.86,8.59-4.79,12.68a19.93,19.93,0,0,1-25.55,10",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.49,471a2.63,2.63,0,0,1,0-.64c0-.42,0-1,0-1.84,0-1.6.2-3.91.55-6.75a88,88,0,0,1,1.8-9.88,45.41,45.41,0,0,1,4.51-11.45,47.69,47.69,0,0,1,15.11-16.28c1.18-.81,2.33-1.42,3.31-2s1.89-1,2.61-1.3l1.7-.71a2.89,2.89,0,0,1,.61-.21,2.89,2.89,0,0,1-.57.31l-1.65.79c-.71.37-1.57.82-2.56,1.37s-2.08,1.22-3.24,2.05a48.88,48.88,0,0,0-14.87,16.22c-4.33,7.57-5.52,15.54-6.39,21.13-.4,2.82-.6,5.12-.72,6.71q-.08,1.13-.12,1.83A3,3,0,0,1,114.49,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.49,409.93c-8.72,5.27-8.7,10.06-7.24,14.59s6.81,7.66,11.26,6c2.51-1,4.32-3.14,5.88-5.33s3-4.54,5.19-6.12,5.33-2.17,7.51-.61",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.49,409.93c-8.72,5.27-8.7,10.06-7.24,14.59s6.81,7.66,11.26,6c2.51-1,4.32-3.14,5.88-5.33s3-4.54,5.19-6.12,5.33-2.17,7.51-.61"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M67,415.71c2.28-3.16,7.92-4.07,11.48-2.5s6.17,4.7,8.5,7.81,4.61,6.41,7.84,8.57,7.75,3,11,.77a9.42,9.42,0,0,0,3.73-6.45,21.48,21.48,0,0,0-.52-7.61c-.77-3.66-2-7.48-4.95-9.81-3.27-2.59-7.8-2.71-12-2.58-4.78.16-9.63.52-14.12,2.18s-9.07,5.23-11,9.62",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.92,470.59a5,5,0,0,1-.06-.75c0-.55,0-1.27-.09-2.17-.06-1.94-.14-4.64-.25-8s-.25-7.37-.5-11.81-.58-9.31-1.25-14.39a47.16,47.16,0,0,0-1.45-7.3,37.21,37.21,0,0,0-2.66-6.39,34.62,34.62,0,0,0-7-9.34A27.29,27.29,0,0,0,87.11,406a20,20,0,0,0-2-.87,3.12,3.12,0,0,1-.69-.31,6.86,6.86,0,0,1,.73.21,18.3,18.3,0,0,1,2,.78,26.14,26.14,0,0,1,6.67,4.38,34.33,34.33,0,0,1,7.21,9.38,37.31,37.31,0,0,1,2.73,6.46,46,46,0,0,1,1.47,7.39c.68,5.1,1,10,1.22,14.44s.33,8.45.39,11.82.08,6.09.08,8c0,.9,0,1.62,0,2.17A3.13,3.13,0,0,1,106.92,470.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,470.59s0-.08-.09-.24l-.23-.73c-.2-.65-.43-1.61-.68-2.87a49.29,49.29,0,0,1-.68-10.8,65.26,65.26,0,0,1,2.62-15.84c1.75-5.79,4.24-12,6.44-18.55a81.29,81.29,0,0,0,4.07-19.11,129.44,129.44,0,0,0,.37-16c-.14-4.56-.37-8.25-.52-10.8-.07-1.24-.12-2.22-.16-2.93,0-.31,0-.57,0-.77a1,1,0,0,1,0-.26,1.11,1.11,0,0,1,0,.26c0,.2,0,.45.09.76.06.71.15,1.69.25,2.93.21,2.54.5,6.23.69,10.79a126.54,126.54,0,0,1-.26,16.05,80.56,80.56,0,0,1-4.06,19.23c-2.2,6.62-4.7,12.78-6.47,18.54A66.51,66.51,0,0,0,109.5,456a51.66,51.66,0,0,0,.51,10.75c.22,1.25.41,2.22.58,2.87.07.3.13.55.18.74A1.27,1.27,0,0,1,110.81,470.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.81,
    y: 311.33,
    width: 8.67,
    height: 159.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.91,305.88a8.74,8.74,0,1,1-8.74-8.74A8.73,8.73,0,0,1,452.91,305.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.09,
    y: 311.33,
    width: 8.67,
    height: 159.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.18,305.88a8.74,8.74,0,1,1-8.73-8.74A8.73,8.73,0,0,1,625.18,305.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.07,
    y: 326.71,
    width: 222.11,
    height: 39.74,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.2 326.71 439.81 327.37 416.99 366.45 415.06 366.45 415.06 326.71 440.2 326.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.34 326.71 473.11 366.45 442.76 366.45 451.99 350.66 465.99 326.71 496.34 326.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.45 326.71 529.23 366.45 498.88 366.45 522.1 326.71 552.45 326.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.57 326.72 585.33 366.45 554.99 366.45 578.22 326.72 608.57 326.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "637.17 326.72 637.17 366.45 611.11 366.45 634.34 326.72 637.17 326.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.07,
    y: 388.1,
    width: 222.11,
    height: 39.74,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.2 388.1 439.81 388.76 416.99 427.84 415.06 427.84 415.06 388.1 440.2 388.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.34 388.1 473.11 427.84 442.76 427.84 451.99 412.06 465.99 388.1 496.34 388.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.45 388.1 529.23 427.84 498.88 427.84 522.1 388.1 552.45 388.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.57 388.11 585.33 427.84 554.99 427.84 578.22 388.11 608.57 388.11",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "637.17 388.11 637.17 427.84 611.11 427.84 634.34 388.11 637.17 388.11",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.17,366.45s0-.24,0-.69,0-1.12,0-2c0-1.77,0-4.36-.06-7.73,0-6.76-.07-16.67-.13-29.34l.23.23-222.09.21h0l.43-.44v39.74l-.43-.44,158.12.2,46.88.12,12.67.06,3.29,0,1.14,0s-.35,0-1.08,0l-3.24,0-12.57.05-46.79.13-158.42.19h-.44V326.27h.45l222.09.21h.23v.23c0,12.73-.1,22.68-.13,29.48q0,5,0,7.67c0,.84,0,1.49,0,1.95S637.17,366.45,637.17,366.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.17,427.84s0-.24,0-.68,0-1.13,0-2c0-1.77,0-4.35-.06-7.73,0-6.76-.07-16.66-.13-29.34l.23.23-222.09.21h0l.43-.44v39.74l-.43-.43,158.12.19,46.88.13,12.67,0,3.29,0,1.14,0s-.35,0-1.08,0l-3.24,0-12.57.06-46.79.12-158.42.2h-.44V387.66h.45l222.09.21h.23v.23c0,12.74-.1,22.68-.13,29.48q0,5,0,7.67c0,.84,0,1.49,0,1.95S637.17,427.84,637.17,427.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.78,470.7c0,.14-140.5.26-313.76.26s-313.8-.12-313.8-.26,140.47-.26,313.8-.26S687.78,470.55,687.78,470.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.26,
    y: 227.91,
    width: 9.1,
    height: 242.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,470.7s0-.44,0-1.26,0-2.07,0-3.67c0-3.23,0-8,0-14.09,0-12.23,0-29.93-.08-51.85,0-43.81-.07-104.47-.11-171.92l.26.26h-9.1l.26-.26c-.1,117-.18,215.29-.2,242.79l-.06-.07,6.87,0c1.5,0,2.23,0,2.23,0l-2.19,0-6.91,0h-.07v-.06c0-27.5-.1-125.8-.19-242.79v-.26h9.62v.26c0,67.53-.08,128.26-.11,172.11,0,21.9-.06,39.57-.08,51.79,0,6.09,0,10.81,0,14,0,1.59,0,2.8,0,3.63S158.36,470.7,158.36,470.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.81,
    cy: 185.08,
    r: 52.94,
    transform: "translate(-62 78.59) rotate(-24.01)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.46,183.09a3.87,3.87,0,0,1-.09-.77c0-.55-.09-1.3-.16-2.26,0-.5-.07-1.06-.1-1.67s-.2-1.27-.31-2a33.59,33.59,0,0,0-1-4.91,45,45,0,0,0-5.29-12.61,47.38,47.38,0,0,0-12.06-13.42,46.84,46.84,0,0,0-19.91-8.81,47.48,47.48,0,0,0-24.81,2.07,49.91,49.91,0,0,0-6.16,2.71c-1,.54-1.95,1.17-2.94,1.76a24.73,24.73,0,0,0-2.84,2,53.42,53.42,0,0,0-5.36,4.56,51.94,51.94,0,0,0-4.62,5.47,45.78,45.78,0,0,0-6.75,13,46.87,46.87,0,0,0,0,29.79,45.88,45.88,0,0,0,6.74,13,53.18,53.18,0,0,0,4.63,5.48,54.55,54.55,0,0,0,5.35,4.55,24.55,24.55,0,0,0,2.85,2c1,.58,1.95,1.21,2.94,1.75a47.44,47.44,0,0,0,62.94-17.44,45.29,45.29,0,0,0,5.29-12.61,33.86,33.86,0,0,0,1-4.91c.11-.72.24-1.38.31-2s.07-1.16.1-1.66c.07-1,.12-1.71.16-2.26a3.87,3.87,0,0,1,.09-.77,5,5,0,0,1,0,.77c0,.55,0,1.31-.06,2.27,0,.5,0,1.06-.07,1.67s-.17,1.28-.26,2a34.77,34.77,0,0,1-.93,4.95,44.94,44.94,0,0,1-5.2,12.79,47.86,47.86,0,0,1-32.27,22.71,48.14,48.14,0,0,1-25.24-2,49.5,49.5,0,0,1-6.27-2.75c-1-.55-2-1.19-3-1.78a23.84,23.84,0,0,1-2.91-2,44,44,0,0,1-10.18-10.2,46.52,46.52,0,0,1-6.89-13.25,47.61,47.61,0,0,1,0-30.36,46.83,46.83,0,0,1,6.88-13.24,55.07,55.07,0,0,1,4.72-5.57,54,54,0,0,1,5.47-4.63,24.44,24.44,0,0,1,2.9-2c1-.6,2-1.24,3-1.79a51.57,51.57,0,0,1,6.27-2.74,48,48,0,0,1,25.24-2,48,48,0,0,1,32.27,22.71,45.17,45.17,0,0,1,5.2,12.79,34.62,34.62,0,0,1,.93,5c.09.72.21,1.39.26,2s0,1.17.07,1.67c0,1,0,1.72.06,2.28A5,5,0,0,1,201.46,183.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 177.12,
    width: 55.13,
    height: 11.5,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.08,133.24c-1.29.09.4,2.87-.87,3.12-1.65.32-3.23-.9-4.21-2.26s-1.67-3-2.93-4.09c-1.65-1.46-4-1.82-6.06-2.54a17,17,0,0,1-9.64-23.83l7.31-14.89c-2.27-1.44-2.82-4.76-1.59-7.14a8.76,8.76,0,0,1,6.5-4.26,12.41,12.41,0,0,1,10.65,3.52c1.47,1.5,2.65,3.46,4.64,4.15,1.74.61,3.67.06,5.51.3a8.28,8.28,0,0,1,5.82,4.18,17.77,17.77,0,0,1,2.07,7c.27,2.25.44,4.72,2,6.36,0,0,2.42,2.19,2.42,4.7,0,5.75-5.51,4.67-5.75,6.78-.45,4.13,1.3,6.07-2.77,8.63,0,0,.74,1.84-2,5.06s-5.69,2.84-5.69,2.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.88,92.34a3.77,3.77,0,0,0-3.38,3.83h0l2.26,50.9c.09,6,8.91,9.38,15.37,9.23h0c6.53-.15,6.74-3.33,6.82-9.05.13-9.56.12-13.14.13-13.09s8.24-1.38,9.92-12.1c.84-5.33.55-14.07.08-21.21-.42-6.42-4.71-14.3-11.14-13.61Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.5,107a1.37,1.37,0,0,1-1.32,1.39,1.33,1.33,0,0,1-1.43-1.24,1.38,1.38,0,0,1,1.33-1.39A1.32,1.32,0,0,1,358.5,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,105.78c-.17.18-1.22-.58-2.7-.58s-2.57.75-2.73.57.09-.4.56-.75a3.8,3.8,0,0,1,2.19-.67,3.65,3.65,0,0,1,2.15.68C360.12,105.38,360.27,105.7,360.19,105.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,107.53a1.37,1.37,0,0,1-1.33,1.39,1.31,1.31,0,0,1-1.42-1.23,1.37,1.37,0,0,1,1.32-1.39A1.32,1.32,0,0,1,344.26,107.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.47,106.16c-.17.18-1.22-.59-2.7-.58s-2.58.75-2.74.57.1-.41.57-.75a3.84,3.84,0,0,1,2.19-.68,3.68,3.68,0,0,1,2.15.69C345.39,105.76,345.55,106.08,345.47,106.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,116.67a9.3,9.3,0,0,1,2.41-.44c.38,0,.74-.12.8-.38a1.94,1.94,0,0,0-.25-1.12c-.36-.91-.74-1.86-1.13-2.87-1.57-4.09-2.7-7.45-2.53-7.51s1.57,3.2,3.13,7.29c.38,1,.74,2,1.08,2.89a2.16,2.16,0,0,1,.2,1.48,1,1,0,0,1-.62.56,2.72,2.72,0,0,1-.64.09A10.3,10.3,0,0,1,351,116.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.08,134.16a27.5,27.5,0,0,1-14.42-3.79s3.65,7.55,14.42,6.52Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.39,120.23a2.65,2.65,0,0,0-2.4-1,2.45,2.45,0,0,0-1.68.9,1.55,1.55,0,0,0-.12,1.76,1.81,1.81,0,0,0,1.95.49,5.67,5.67,0,0,0,1.9-1.13,1.6,1.6,0,0,0,.42-.44.48.48,0,0,0,0-.55",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,103.5c-.23.35-1.63-.16-3.38-.35s-3.22-.05-3.36-.45c-.06-.19.26-.51.9-.76a6,6,0,0,1,5.14.61C345.73,102.94,346,103.32,345.86,103.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.12,103c-.28.37-1.58.18-3.1.34s-2.78.55-3.12.24c-.15-.16,0-.52.54-.9a5.17,5.17,0,0,1,2.46-.84,5,5,0,0,1,2.55.38C360,102.47,360.24,102.79,360.12,103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.78,86.44a7.42,7.42,0,0,0,2.63,5.65,7.51,7.51,0,0,0,6,1.59c1.64-.3,3.45-1.13,4.87-.26s1.56,3.17,2.88,4.32c1.9,1.64,4.91.1,7.32.81,1.86.55,3,2.32,4.26,3.81s3.08,2.9,4.94,2.35a21.61,21.61,0,0,0-.74-4.94,7.32,7.32,0,0,0-2.81-4c-.77-.5-1.67-.81-2.38-1.38-1.54-1.24-1.9-3.4-2.86-5.14a8.06,8.06,0,0,0-6.14-4.06c-2.11-.21-4.3.42-6.36-.1-1.52-.38-2.85-1.37-4.4-1.66-3-.57-5.8,1.58-8,3.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.12,109.66a1.19,1.19,0,0,0,.45,2.27c3.62.81,4.09-6.22,3.29-8.23a20.69,20.69,0,0,0,3.62-3.8,15,15,0,0,0,1.67-7.28c1.3.08,6.85-1.75,6.26-1.91-1.35-.39-4.11-1.26-4.83-2.42a8.28,8.28,0,0,0-7.17-4.11,6.81,6.81,0,0,0-6.13,5.36,9.8,9.8,0,0,0-8.41,5.39,11.24,11.24,0,0,0,.31,10.5,5.61,5.61,0,0,1,1.1,2.59c0,1.2-.87,2.14-1.5,3.13-1.7,2.69-1.57,6.38-.26,9.31s2.25,4,4.13,4.54c3.66,1.15-.59,8.68,5.51,8.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.27,112.6a3.14,3.14,0,0,0-4.59-2.66c-1.09.63-1.93,1.89-1.83,4.31.27,6.46,6.72,4.86,6.72,4.67S331.4,115.27,331.27,112.6Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.49,116.56s-.11.08-.29.18a1.18,1.18,0,0,1-.85.05,2.78,2.78,0,0,1-1.39-2.44,3.73,3.73,0,0,1,.25-1.63,1.32,1.32,0,0,1,.81-.9.58.58,0,0,1,.68.29c.09.17.06.3.09.31s.14-.11.07-.38a.71.71,0,0,0-.27-.39.88.88,0,0,0-.63-.14,1.59,1.59,0,0,0-1.14,1,3.84,3.84,0,0,0-.31,1.82,2.93,2.93,0,0,0,1.76,2.72,1.2,1.2,0,0,0,1-.22C329.49,116.71,329.52,116.57,329.49,116.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.49,89a3.86,3.86,0,0,0-1.3,1.08,5.92,5.92,0,0,0-.47,4.46l0,.17-.16,0a6.21,6.21,0,0,0-4.17,3.66,5,5,0,0,0-.34,1.57,10.45,10.45,0,0,0,.2,1.71,11.83,11.83,0,0,1,.25,1.84,3,3,0,0,1-.51,1.9,7.94,7.94,0,0,1-3.22,2.41,10.67,10.67,0,0,0-3,2,8,8,0,0,0-2.42,5.41,8.37,8.37,0,0,0,.85,4c.43.88.79,1.3.75,1.32s-.1-.09-.27-.29a6.3,6.3,0,0,1-.64-1,8.16,8.16,0,0,1,1.43-9.78,11.11,11.11,0,0,1,3.1-2.06,7.49,7.49,0,0,0,3-2.26c.72-1,.4-2.26.21-3.41a10.66,10.66,0,0,1-.2-1.79,5.45,5.45,0,0,1,.38-1.73,6.56,6.56,0,0,1,4.49-3.83l-.12.2a6,6,0,0,1,.65-4.65,2.72,2.72,0,0,1,1-.82A2.12,2.12,0,0,1,337.49,89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.29,122.36a9.34,9.34,0,0,1-2.47-1.32c-1.31-.78-2.39-1.39-2.32-1.55s1.29.21,2.64,1S350.4,122.23,350.29,122.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.74,110.61c-.06-.19.7-.44,1.55-1.35a4.09,4.09,0,0,0,1-1.9,3.79,3.79,0,0,0-.41-2.63,6.32,6.32,0,0,0-2.65-2.17,14.16,14.16,0,0,1-2-1.32,7,7,0,0,1-1.78-2.18c-.89-1.64-1.23-3.43-1.86-4.84a5.86,5.86,0,0,0-1.2-1.85,2.73,2.73,0,0,0-1.69-.81c-1.43-.2-3.33.51-5.56.1a7,7,0,0,1-2.85-1.37,16.53,16.53,0,0,1-1.94-1.85,13.21,13.21,0,0,0-3.15-2.82,6.83,6.83,0,0,0-3.36-.8,7.18,7.18,0,0,0-4.72,2.05c-.94.89-1.31,1.57-1.5,1.49s-.09-.9.73-2.14a7.07,7.07,0,0,1,1.91-1.93,7.54,7.54,0,0,1,3.43-1.3,8.37,8.37,0,0,1,4.47.69A14.14,14.14,0,0,1,351,86.77a7.36,7.36,0,0,0,3.56,2.39,8.21,8.21,0,0,0,2.3,0A13,13,0,0,1,360,89a5.3,5.3,0,0,1,3.22,1.55,8.2,8.2,0,0,1,1.71,2.68c.75,1.85,1,3.49,1.65,4.75a5,5,0,0,0,1.13,1.54,14.28,14.28,0,0,0,1.68,1.22,13.93,13.93,0,0,1,1.81,1.35,5.72,5.72,0,0,1,1.37,1.85,5.3,5.3,0,0,1,.15,3.86A4.63,4.63,0,0,1,371,110C369.66,110.89,368.75,110.76,368.74,110.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,130.92l-1.84,6.94s-9.22,13.26-10.65,15.51-4.71,10.61-5.12,14.69,14.34,62,14.34,61.42,42.4,12,42.4,12l8.65-7.81s1.46-18.89.64-20.53-.9-26.55-3.15-35.73-20.06-29.68-20.06-29.68L352,143.23l0,4.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.11,158.59A19.43,19.43,0,0,0,326,178.35c6.68,9.16,16.29,22.18,17.05,22.18,1.18,0,24.92-21.9,24.92-21.9S354.8,158,348,153.39c-3.22-2.15-13.27-6.2-17.67-3.92C328.37,150.47,326.08,154.44,324.11,158.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.07,148.81c-.2,0,0-1.76.52-3.8a15.72,15.72,0,0,1,1.17-3.65,13.41,13.41,0,0,1-.66,3.77A31.45,31.45,0,0,1,332.07,148.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,147.71a4.35,4.35,0,0,1-.78-.44l-2.11-1.38.23-.11a15.22,15.22,0,0,0,.4,3.06,19.33,19.33,0,0,1,.54,3.95v.47l-.37-.31c-2-1.64-4.34-3.46-6.91-5.3-4.31-3.08-8.37-5.63-11.38-7.36-1.5-.88-2.74-1.55-3.59-2a8.66,8.66,0,0,1-1.31-.75,7.38,7.38,0,0,1,1.4.57c.88.42,2.15,1,3.68,1.87a115.29,115.29,0,0,1,11.51,7.27c2.57,1.85,4.92,3.69,6.9,5.37l-.38.16a19.88,19.88,0,0,0-.47-3.85,13.65,13.65,0,0,1-.3-3.15l0-.27.21.16,2,1.49A3.52,3.52,0,0,1,352,147.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,197.19l0-.05Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,197.14Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.69,192.32c-2.79-1.75-7.49-.58-7.49-.58L366.53,180,347,197.19c2,2.4,15.93,13.87,20.95,15.47,5.54,1.75,11.71.73,13.76-2.2s5.29-7.31,5.29-7.31S388.48,194.08,385.69,192.32Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.54,177.38l5.89,4.13s5.4.58,7.53,5.48,2.56,15.68-4.56,15.88l-16.11-11.74v-9Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.33,186.11c-.05.07-.9-.67-2.47-1.5a15,15,0,0,0-13.32-.41c-1.62.72-2.51,1.41-2.56,1.33s.18-.22.58-.53a12.13,12.13,0,0,1,1.82-1.14,14.17,14.17,0,0,1,13.66.43,12,12,0,0,1,1.75,1.25C390.17,185.87,390.36,186.08,390.33,186.11Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.76 180.48 380.37 176.13 357.01 151.8 373.76 180.48",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.08,182.58s.1.09.27.3l.75.92,2.84,3.55L343.2,200.4l-.29,0c.89-.73,1.8-1.5,2.74-2.28s1.86-1.65,2.82-2.51c1.93-1.72,4-3.53,6.06-5.42l13.54-12.08-.05.33c-1.17-1.77-2.45-3.63-3.78-5.48-2.53-3.54-5.13-6.89-7.75-10.05-1.3-1.58-2.62-3.11-3.92-4.58a45,45,0,0,0-4-4.12,19.16,19.16,0,0,0-4.52-3,24.65,24.65,0,0,0-4.91-1.54,40.89,40.89,0,0,0-4.75-.79,7.07,7.07,0,0,0-4.2.9,11.07,11.07,0,0,0-3,2.63,22.57,22.57,0,0,0-2.05,3,25.56,25.56,0,0,0-2.31,5.29,26.43,26.43,0,0,0-.82,3.56c-.06.4-.1.71-.14,1a1.43,1.43,0,0,1-.06.32,19.77,19.77,0,0,1,.83-4.89,24.83,24.83,0,0,1,2.25-5.37,22.68,22.68,0,0,1,2-3,11.52,11.52,0,0,1,3.07-2.74,7.47,7.47,0,0,1,4.4-1,38.25,38.25,0,0,1,4.82.77,24.24,24.24,0,0,1,5,1.55,19.09,19.09,0,0,1,4.65,3,44.5,44.5,0,0,1,4.08,4.15c1.31,1.47,2.63,3,3.94,4.58,2.63,3.17,5.24,6.53,7.78,10.07,1.34,1.86,2.62,3.73,3.8,5.51l.12.18-.17.15-13.56,12.06-6.09,5.4c-1,.85-1.9,1.7-2.83,2.49l-2.76,2.27-.16.13-.13-.16-10.12-13.16L330,183.87l-.7-1A2.38,2.38,0,0,1,329.08,182.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,203.15c-.05,0,.13-.51.3-1.41a7.56,7.56,0,0,0,.09-1.66c0-.67.06-1.43.06-2.24a8.59,8.59,0,0,0-1.7-5.32,6.76,6.76,0,0,0-6.18-2.26,6.17,6.17,0,0,0-2.43.89l-.18.12-.15-.15c-3.1-3.17-5.82-6-7.75-8l-2.26-2.41a4.94,4.94,0,0,1-.77-.92,6.45,6.45,0,0,1,.9.79l2.37,2.3c2,2,4.77,4.74,7.88,7.9l-.32,0a6.52,6.52,0,0,1,2.63-1,7.19,7.19,0,0,1,6.64,2.48,8.82,8.82,0,0,1,1.69,5.62c0,.85-.13,1.58-.14,2.24a6.84,6.84,0,0,1-.51,2.73C387.08,203,387,203.15,387,203.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,152.52a7.35,7.35,0,0,1,1,1.08c.59.71,1.43,1.75,2.45,3.06a86.16,86.16,0,0,1,7.33,10.69,33.06,33.06,0,0,1,2.88,6.56,15.5,15.5,0,0,1,.68,5.81c-.06,1.58-.11,2.9-.15,3.93a7.24,7.24,0,0,1-.13,1.43,8.11,8.11,0,0,1-.07-1.43c0-1,0-2.35,0-3.93a16,16,0,0,0-.78-5.67,34.5,34.5,0,0,0-2.87-6.44,105.13,105.13,0,0,0-7.17-10.73c-.94-1.27-1.72-2.33-2.32-3.16A7.71,7.71,0,0,1,357,152.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,214c.15-.05,1.06,3,3.06,6.43s4.22,5.71,4.1,5.82a6.49,6.49,0,0,1-1.55-1.44,25.44,25.44,0,0,1-5.12-8.76A6.41,6.41,0,0,1,343,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.71,227.52a39.89,39.89,0,0,1-2.65-8.63,38.46,38.46,0,0,1,2.65,8.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.91,161.42c.16-.26,2.94,5.7,2.94,5.7s1.37,3.94-3.31,6.18a5,5,0,0,1-7.05-2.4l-2-4.39a4.51,4.51,0,0,0,3.61-4.34S338,164.41,339.91,161.42Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.2,438.93l-1.39,21s20.88,6.93,21,10.83L349,471l.83-32.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,471l.09-3.3,39.4,1.08A2.84,2.84,0,0,1,390,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.9,272.31l1.81-34.25-53.13-1.95s-6.79,16-8.4,22.19-2.66,14.2-.59,22,17,33.91,17,33.91L345.9,458.36h32.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,244c.39,3.9,30.21,96.09,26.83,110.14s-27.54,80.05-27.54,80.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.43,250.13c.14,0,.55,38.6.92,86.21s.54,86.22.4,86.22-.56-38.6-.92-86.22S375.28,250.13,375.43,250.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.88,458.36c-.14,0-1.9-45.2-3.93-100.95s-3.55-101-3.41-101,1.9,45.19,3.93,101S366,458.36,365.88,458.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.87,242.09a7.64,7.64,0,0,1-.13,1.4,25.31,25.31,0,0,1-.89,3.72,29.21,29.21,0,0,1-6.3,10.89c-3.33,3.66-7.27,6.16-10.48,6.89a9.17,9.17,0,0,1-3.84.15,8.11,8.11,0,0,1-1-.29c-.22-.09-.33-.14-.33-.16s.49.12,1.37.25a9.7,9.7,0,0,0,3.72-.31c3.08-.79,6.91-3.28,10.19-6.88a30.7,30.7,0,0,0,6.33-10.66C356.56,244.07,356.75,242.07,356.87,242.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,346.44a24.57,24.57,0,0,0-13.87,2.08,6.12,6.12,0,0,1,1.81-1.09,17.66,17.66,0,0,1,4.89-1.48,18.19,18.19,0,0,1,5.11,0A6.16,6.16,0,0,1,390,346.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,326.4a16.69,16.69,0,0,1-1.5-2.5c-.88-1.56-2.1-3.72-3.51-6.07s-2.75-4.45-3.71-6a19.23,19.23,0,0,1-1.51-2.5,14.63,14.63,0,0,1,1.81,2.29c1.05,1.47,2.43,3.54,3.85,5.9s2.6,4.55,3.4,6.17A14.57,14.57,0,0,1,340,326.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.56,222.39c-.82-.27-1.31,15.16-1.31,15.16s26.82,5.23,54.42,1.16l.72-13.47S353.49,232.34,323.56,222.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.37,257.38h0a4.8,4.8,0,0,1-4.79-4.8v-20a4.8,4.8,0,0,1,4.79-4.8h0a4.8,4.8,0,0,1,4.8,4.8v20A4.8,4.8,0,0,1,344.37,257.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.37,257.38a6.29,6.29,0,0,1,.71-.11,4.84,4.84,0,0,0,1.84-.75,4.62,4.62,0,0,0,1.86-2.46,5.48,5.48,0,0,0,.23-1.94c0-.72,0-1.47,0-2.26,0-3.19,0-7-.06-11.13,0-2.09,0-4.32,0-6.55a4.54,4.54,0,0,0-9,0c-.05,2.23,0,4.46,0,6.55,0,4.17,0,7.94-.06,11.13,0,.79,0,1.54,0,2.26a5.48,5.48,0,0,0,.23,1.94,4.62,4.62,0,0,0,1.86,2.46,4.84,4.84,0,0,0,1.84.75,5.34,5.34,0,0,1,.7.11,2.39,2.39,0,0,1-.71,0,4.41,4.41,0,0,1-1.94-.68,4.87,4.87,0,0,1-2-2.54,5.84,5.84,0,0,1-.28-2c0-.72,0-1.47,0-2.26,0-3.19,0-7-.05-11.13,0-2.11,0-4.27,0-6.6a5,5,0,0,1,10,0c.05,2.33,0,4.49,0,6.6,0,4.17,0,7.94-.06,11.13,0,.79,0,1.54,0,2.26a5.84,5.84,0,0,1-.28,2,4.87,4.87,0,0,1-2,2.54,4.41,4.41,0,0,1-1.94.68A2.47,2.47,0,0,1,344.37,257.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.36,236.3a1.35,1.35,0,0,0-1.14,1.12,1.2,1.2,0,0,0,.88,1.3,1.33,1.33,0,0,0,1.43-.95,1.24,1.24,0,0,0-1.17-1.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.36,236.3s.11-.07.31,0a1.15,1.15,0,0,1,.77.41,1.5,1.5,0,0,1,.28,1.31,1.57,1.57,0,0,1-1.3,1,1.33,1.33,0,0,1-1.36-.94,1.35,1.35,0,0,1,.24-1.31c.53-.59,1.08-.49,1.06-.44s-.43.15-.76.66a1,1,0,0,0-.09.93.87.87,0,0,0,.85.58,1.17,1.17,0,0,0,.91-.64,1.21,1.21,0,0,0-.12-.94C344.83,236.41,344.33,236.39,344.36,236.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,241.71a10.1,10.1,0,0,0,9.9.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.28,242.46c0,.06-.46.4-1.37.72a9.12,9.12,0,0,1-3.7.47,9.29,9.29,0,0,1-3.59-1c-.85-.45-1.28-.86-1.24-.91a16.18,16.18,0,0,0,4.87,1.42A15.84,15.84,0,0,0,349.28,242.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,284.3h0a5,5,0,0,1-4.9-5.05l.87-55.75a5,5,0,0,1,5.05-4.89h0a5,5,0,0,1,4.9,5l-.87,55.74A5,5,0,0,1,329.81,284.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81,284.3a9.55,9.55,0,0,0,1.42-.24,5,5,0,0,0,3-2.58,5.72,5.72,0,0,0,.5-2.88c0-1.1,0-2.3,0-3.58,0-2.57.07-5.49.1-8.71.09-6.47.19-14.16.3-22.69.06-4.27.12-8.75.19-13.39,0-2.31.09-4.72.08-7.06a4.72,4.72,0,0,0-9.38-.15c-.09,2.34-.09,4.75-.14,7.06-.08,4.64-.15,9.12-.22,13.4-.15,8.53-.29,16.21-.41,22.68-.06,3.22-.12,6.14-.17,8.71,0,1.28-.06,2.48-.08,3.58a5.8,5.8,0,0,0,.41,2.89A5,5,0,0,0,328.4,284a9,9,0,0,0,1.41.28,4,4,0,0,1-1.44-.18,5,5,0,0,1-3.1-2.69,6.11,6.11,0,0,1-.47-3c0-1.1,0-2.29,0-3.57,0-2.57.06-5.49.09-8.72.09-6.46.19-14.15.3-22.68.06-4.27.12-8.75.19-13.4.05-2.33,0-4.66.14-7.11a5.24,5.24,0,0,1,10.41.16c0,2.45-.07,4.78-.09,7.11-.08,4.65-.15,9.13-.22,13.4-.16,8.53-.29,16.22-.41,22.68-.06,3.23-.12,6.15-.17,8.72,0,1.28-.06,2.47-.08,3.57a6,6,0,0,1-.56,3,5,5,0,0,1-3.18,2.59A3.91,3.91,0,0,1,329.81,284.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,256.8h0A4.79,4.79,0,0,1,354,252v-20a4.8,4.8,0,0,1,4.8-4.8h0a4.8,4.8,0,0,1,4.79,4.8v20A4.79,4.79,0,0,1,358.84,256.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,256.8s.24,0,.7-.11a4.79,4.79,0,0,0,1.84-.74,4.65,4.65,0,0,0,1.86-2.47,5.45,5.45,0,0,0,.23-1.94c0-.71,0-1.47,0-2.26,0-3.19,0-7-.06-11.13,0-2.08,0-4.32,0-6.55a4.53,4.53,0,0,0-7.59-2.88,4.61,4.61,0,0,0-1.44,2.88c-.05,2.23,0,4.47,0,6.55,0,4.18,0,7.94-.06,11.13,0,.79,0,1.55,0,2.26a5.24,5.24,0,0,0,.22,1.94,4.7,4.7,0,0,0,1.86,2.47,4.77,4.77,0,0,0,1.85.74c.45.09.7.09.7.11a2.64,2.64,0,0,1-.72,0,4.69,4.69,0,0,1-1.94-.68,5,5,0,0,1-2-2.54,5.9,5.9,0,0,1-.28-2c0-.71,0-1.47,0-2.26,0-3.19,0-6.95-.06-11.13,0-2.11,0-4.27,0-6.6a5.07,5.07,0,0,1,5-4.56,5.05,5.05,0,0,1,5,4.56c.05,2.33,0,4.49,0,6.6,0,4.17,0,7.94-.05,11.13,0,.79,0,1.55,0,2.26a5.9,5.9,0,0,1-.28,2,5,5,0,0,1-2,2.54,4.69,4.69,0,0,1-1.94.68A2.55,2.55,0,0,1,358.84,256.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.82,234.76a1.37,1.37,0,0,0-1.14,1.13,1.2,1.2,0,0,0,.88,1.29,1.31,1.31,0,0,0,1.43-.94,1.25,1.25,0,0,0-1.17-1.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.82,234.76s.11-.06.31,0a1.17,1.17,0,0,1,.78.42,1.52,1.52,0,0,1,.27,1.31,1.56,1.56,0,0,1-1.3,1,1.36,1.36,0,0,1-1.11-2.24c.52-.59,1.07-.5,1.05-.45s-.43.16-.76.66a1,1,0,0,0-.09.93.89.89,0,0,0,.85.59,1,1,0,0,0,.79-1.58C359.29,234.88,358.79,234.86,358.82,234.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,246.59a1.36,1.36,0,0,0-1.14,1.12,1.21,1.21,0,0,0,.88,1.3,1.32,1.32,0,0,0,1.43-.95,1.23,1.23,0,0,0-1.17-1.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,246.59s.11-.07.32-.05a1.27,1.27,0,0,1,.77.42,1.52,1.52,0,0,1,.28,1.31,1.6,1.6,0,0,1-1.31,1,1.37,1.37,0,0,1-1.11-2.25c.53-.59,1.07-.5,1-.44s-.43.15-.75.66a1,1,0,0,0-.1.92.89.89,0,0,0,.86.59,1,1,0,0,0,.78-1.58C359.31,246.7,358.81,246.68,358.84,246.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.55,433l-6.83,27.08L197.15,480a2.87,2.87,0,0,0,1.2,4h0a2.85,2.85,0,0,0,2.62,0l26.17-16.26,7.58-27.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,483.92l26.17-16.26,1.12-4-30.11,20.2A2.94,2.94,0,0,0,201,483.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.22,439l-1.4,21.17s21.07,7,21.19,10.93l-41.16.3.83-33.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.85,471.43l.08-3.34,39.76,1.1a2.84,2.84,0,0,1,1.53,2.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.22,125.8c-.78-1.34-1-2.42-.64-4.78s2.4-19.13,2.66-20.48c.5-2.61,2.41-3.28,2.65-1.37s.33,9.47.81,9.58,1-12.11,2-13.48,1.89-1.38,2.36-.79a3.28,3.28,0,0,1,.59,1s.85-1.48,1.82-1.39c1.78.17,1.81,2.35,1.81,2.35l.14,5.18s.15-4.17,1.35-4.73c.67-.32,1.6-.11,2,1.15s0,6.34,0,6.69.15,13.57.15,13.57a16.82,16.82,0,0,0,2.39-4.07c.68-1.66,1.82-2.3,3.24-1.95s1.53,1.77,1.06,2.84-1.42,4.3-1.42,4.3l-2.47,4.84-8.52,7.63-3.07,7s-9.87-1-11.06-6.3Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.31,116.71a16.23,16.23,0,0,0-2.57,1.88,10,10,0,0,0-3,6.79c0,.26,0,.53,0,.78l-.52.07a22,22,0,0,0-2.69-6.62c-1-1.55-1.7-2.41-1.63-2.46s.23.17.58.55a15.75,15.75,0,0,1,1.35,1.72,19.67,19.67,0,0,1,2.9,6.7l-.51.08c0-.27,0-.55,0-.83a9.66,9.66,0,0,1,1.09-4.23,10.11,10.11,0,0,1,2.19-2.82,8.61,8.61,0,0,1,2-1.33A2.25,2.25,0,0,1,205.31,116.71Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.12,111.87c0,.16-2.23.29-4.93.74s-4.87,1-4.91.89a14.8,14.8,0,0,1,4.82-1.4A15.17,15.17,0,0,1,205.12,111.87Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.21,110.86a56.3,56.3,0,0,1-.05-7.78,59,59,0,0,1,.48-7.77,57.42,57.42,0,0,1,0,7.78A60,60,0,0,1,201.21,110.86Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,110.74a45.66,45.66,0,0,1-.1-6.86A46.42,46.42,0,0,1,205.3,97a45.81,45.81,0,0,1,.1,6.86A44.7,44.7,0,0,1,205,110.74Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6,240.79a14,14,0,0,1-6.43-6.68c.14-.08,1.24,1.7,3,3.53S243.69,240.66,243.6,240.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.91,229.51c0-.09,1.24.17,3.24.42a44.22,44.22,0,0,0,15.61-.77c2-.45,3.15-.83,3.18-.75a2.78,2.78,0,0,1-.8.37c-.53.21-1.31.46-2.29.74a37,37,0,0,1-15.76.78c-1-.18-1.8-.35-2.35-.51A3.19,3.19,0,0,1,277.91,229.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.19 454.46 302.61 273.67 303.23 227.16 228.86 233.16 204.26 455.63 233.77 454.88 263.87 268.24 262.44 453.59 289.19 454.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,261.7c.14,0-6.21,42.93-14.18,95.82s-14.56,95.78-14.71,95.76,6.21-42.92,14.19-95.83S247.48,261.68,247.62,261.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.22,453.28a4.7,4.7,0,0,1,0-.5c0-.35,0-.83.08-1.45.08-1.31.21-3.19.37-5.6.32-4.88.79-11.9,1.38-20.56,1.14-17.37,2.59-41.38,3.87-67.9s2.14-50.57,2.68-68c.26-8.68.46-15.71.61-20.6.07-2.42.13-4.3.17-5.6,0-.63,0-1.11.06-1.46s0-.5,0-.5a4.79,4.79,0,0,1,0,.5v1.46c0,1.3,0,3.19-.07,5.6-.07,4.87-.22,11.91-.44,20.61-.44,17.4-1.25,41.44-2.53,68s-2.79,50.54-4,67.9c-.61,8.68-1.14,15.71-1.54,20.56-.2,2.41-.36,4.28-.47,5.58-.05.63-.1,1.11-.13,1.46S277.22,453.28,277.22,453.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.57,120.42l-5.25,7.77s-16.77,2.17-19.43,3.38-3.66,5.52-3.66,5.52l4.73,57.2s1.19,24.3,1,28.1h0s0,3.79-.16,6.53a57.52,57.52,0,0,0,.45,7.59s21.41,5.34,23.23,5.18,10.94-2.11,10.94-2.11l27.49-1,8.81-2.88,1.67-4.7-1.06-2s3.8-4.4,4.11-6.68-1-24.75-1-24.75V191l3.85-58s-4.85-3.11-7.56-3.6c-7.57-1.38-14.26-3.29-14.26-3.29l-7.25-8.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,145.91a.73.73,0,0,1,0,.24l0,.7-.25,2.7c-.24,2.34-.54,5.73-.86,9.93s-.63,9.19-.85,14.75-.32,11.67-.27,18.09.31,12.53.61,18.08.72,10.55,1.13,14.73.77,7.58,1.05,9.91c.13,1.14.23,2,.31,2.7l.06.7a1.08,1.08,0,0,1,0,.24.79.79,0,0,1-.06-.23c0-.19-.07-.42-.12-.7-.09-.66-.23-1.55-.4-2.68-.34-2.33-.77-5.71-1.21-9.9s-.89-9.18-1.25-14.74-.58-11.68-.65-18.11.08-12.55.31-18.11.58-10.57,1-14.76.73-7.59,1-9.92c.15-1.14.26-2,.35-2.69l.1-.7A1.16,1.16,0,0,1,263,145.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.39,146.94l16.78,22.35a103.49,103.49,0,0,0,6.39,9c4.11,5.26,18.39,15.33,21.36,15.9s8.23,1.15,11.55-4.79,4.7-18.85,4.7-18.85L307.29,133s-5.66,3.28-8.41,8.65-2.95,16.68-2.95,16.68l-15.78-14.2-6.92-8.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.93,170.53a6.14,6.14,0,0,1-1.45-2.06c-.75-1.37-1.42-3.43-2.48-5.49a10.39,10.39,0,0,0-1.87-2.63,6.79,6.79,0,0,0-2.17-1.46,8,8,0,0,0-2.39-.46s.22-.12.66-.15a4.65,4.65,0,0,1,1.86.27,6.63,6.63,0,0,1,2.37,1.45,10.18,10.18,0,0,1,2,2.73c1.09,2.14,1.69,4.19,2.35,5.58S306,170.49,305.93,170.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.15,144.13a7.3,7.3,0,0,1-1,2.27,18.85,18.85,0,0,1-3.67,4.7,18.21,18.21,0,0,1-5,3.29,7.67,7.67,0,0,1-2.35.76c-.09-.17,3.61-1.28,7-4.43S280,144,280.15,144.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.55,146.83s.12-.1.38-.16a1.57,1.57,0,0,1,1.15.15,1.85,1.85,0,0,1,.84,1.53,1.78,1.78,0,0,1-2.44,1.66,1.8,1.8,0,0,1-.86-2.46,1.4,1.4,0,0,1,.85-.8c.28-.07.43,0,.43,0s-.66.08-.94.92a1.47,1.47,0,0,0,.12,1.34,1.23,1.23,0,0,0,1.43.53,1.27,1.27,0,0,0,.93-1.21,1.53,1.53,0,0,0-.56-1.22,1.56,1.56,0,0,0-.93-.26C266.7,146.87,266.55,146.87,266.55,146.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.12,130.26l-5.48,9.64-3.41,1.2s-14.72,22.27-6.52,29.51,21.6,6.83,26.21,4.62,28.19-12.89,28.19-12.89l-.22-30.77a65.72,65.72,0,0,0-12.07,7.64c-2.94,2.51-17.06,10.62-17.06,10.62l4.2-12.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87,129.88a19,19,0,0,1-2.94,10.27,40,40,0,0,0,12.75-8.09,23.22,23.22,0,0,0,5.45,5.43c-1.23-3.06-3.4-5.62-5.25-8.35s-3.42-5.88-3.18-9.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,199.76a10.14,10.14,0,0,1-.94,1.44c-.32.46-.72,1-1.21,1.62s-1,1.34-1.71,2.08a59.88,59.88,0,0,1-4.87,5,65.79,65.79,0,0,1-6.73,5.3,64.55,64.55,0,0,1-7.41,4.29,57.48,57.48,0,0,1-6.45,2.69c-.94.35-1.81.58-2.56.82s-1.41.4-2,.52a10,10,0,0,1-1.69.35,11.16,11.16,0,0,1,1.64-.54c.53-.16,1.18-.35,1.92-.61s1.6-.52,2.52-.89a65.44,65.44,0,0,0,6.37-2.77,69.54,69.54,0,0,0,7.33-4.29,68.64,68.64,0,0,0,6.69-5.23,65.33,65.33,0,0,0,4.93-4.9c.68-.71,1.24-1.41,1.75-2s.94-1.12,1.27-1.56A10.26,10.26,0,0,1,286.4,199.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,132.18a3.17,3.17,0,0,1-.46,1,10,10,0,0,1-1.91,2.18c-1.81,1.67-4.8,3.29-7.9,5.26l-.25.16-.58.38.19-.66a82.68,82.68,0,0,1,3-8.79c.44-1.1.83-2,1.11-2.57a3.76,3.76,0,0,1,.5-.91,4.53,4.53,0,0,1-.32,1c-.26.73-.58,1.61-.95,2.63-.79,2.23-1.9,5.31-2.87,8.79l-.4-.28.26-.16c3.14-2,6.11-3.54,7.94-5.11A14.61,14.61,0,0,0,252.59,132.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,222.39a3.25,3.25,0,0,1-.08-.73c0-.53-.08-1.23-.13-2.09-.09-1.88-.21-4.49-.36-7.7s-.3-7.13-.48-11.42c-.1-2.15-.15-4.41-.29-6.74s-.4-4.74-.61-7.21c-1.58-19.26-2.72-33.05-3-35.84a2.05,2.05,0,0,1,.17.71c.08.48.17,1.18.28,2.08.21,1.81.48,4.43.79,7.67.62,6.48,1.41,15.43,2.23,25.33.21,2.48.4,4.89.6,7.23s.17,4.6.26,6.75c.13,4.28.26,8.15.36,11.42s.16,5.83.2,7.71c0,.87,0,1.56,0,2.09A4.25,4.25,0,0,1,229,222.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1,146.59c.08,0-.62,1.45-1.52,3.82a49.79,49.79,0,0,0-3.21,14.94c-.12,1.66,0,3.18-.25,4.48a4,4,0,0,1-1.52,2.64,2.45,2.45,0,0,1-.75.36c-.19,0-.29,0-.3,0a5.06,5.06,0,0,0,.93-.55,4,4,0,0,0,1.28-2.54c.18-1.23,0-2.76.13-4.45a43.23,43.23,0,0,1,.58-5.47,43.73,43.73,0,0,1,2.77-9.58c.5-1.17.95-2.1,1.29-2.73A4.58,4.58,0,0,1,199.1,146.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,168.52a13.24,13.24,0,0,1-.23-2.75c-.06-1.69-.08-4,0-6.63s.3-4.93.49-6.62a13.59,13.59,0,0,1,.45-2.72,15.23,15.23,0,0,1-.08,2.75c-.1,1.69-.24,4-.34,6.61s-.14,4.92-.17,6.61A14.62,14.62,0,0,1,197,168.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,148a8.47,8.47,0,0,1-2.64-.23,21.09,21.09,0,0,1-6-2.14,21.65,21.65,0,0,1-5.14-3.82,9,9,0,0,1-1.66-2.07,32.53,32.53,0,0,0,7,5.43A32.15,32.15,0,0,0,198.15,148Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.32,139.15a2.06,2.06,0,0,0-.17,1.16,1.33,1.33,0,0,0,.67.94,1.24,1.24,0,0,0,1.6-1.55,1.38,1.38,0,0,0-.93-.7,2.13,2.13,0,0,0-1.17.15s0-.15.24-.29a1.39,1.39,0,0,1,1-.22,1.67,1.67,0,0,1,1.3.84,1.61,1.61,0,0,1-.38,1.86,1.59,1.59,0,0,1-1.87.34,1.7,1.7,0,0,1-.82-1.31,1.52,1.52,0,0,1,.25-1C195.17,139.18,195.31,139.13,195.32,139.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.15,153.31c.27-.15-.14,6.49-.14,6.49s-.69,4.17-5.92,3.92a5,5,0,0,1-5.09-5.53l.3-4.89a4.57,4.57,0,0,0,5.3-2.14S244.05,155.08,247.15,153.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.28,135.51a6.46,6.46,0,0,1,.28.62c.18.43.44,1,.76,1.83.67,1.64,1.63,4,2.85,7,2.44,6.11,5.94,14.87,10.2,25.51l0,.06v.06c-.66,3.73-1.37,7.69-2.1,11.85a21.25,21.25,0,0,1-2,6.21,17,17,0,0,1-1.85,2.85,11.76,11.76,0,0,1-1.18,1.27,6.82,6.82,0,0,1-1.47,1,11.15,11.15,0,0,1-7,.79,9.4,9.4,0,0,1-3.5-1.13l-3.06-2a102.63,102.63,0,0,1-12.09-9,65,65,0,0,1-8.12-8.78c-2.43-3.07-4.66-6.19-6.76-9.28-4.21-6.16-8.06-12.09-12-17.32l-.13-.16.16-.14,11.86-11,.14-.13.13.13c6.84,7,12.4,12.61,16.27,16.53l4.41,4.53,1.14,1.19c.26.27.38.42.38.42s-.15-.12-.42-.38L294,156.9l-4.49-4.45L273.1,136h.27L261.55,147.1l0-.3c4,5.23,7.83,11.16,12,17.31,2.11,3.07,4.33,6.18,6.75,9.24a65.38,65.38,0,0,0,8.06,8.71,102.78,102.78,0,0,0,12,9l3.05,2a8.94,8.94,0,0,0,3.31,1.06,10.61,10.61,0,0,0,6.7-.73,6.31,6.31,0,0,0,1.37-.92,10.89,10.89,0,0,0,1.13-1.22,15.94,15.94,0,0,0,1.8-2.76,20.84,20.84,0,0,0,2-6.07c.75-4.16,1.47-8.12,2.15-11.85v.11c-4.19-10.67-7.63-19.44-10-25.57L309.21,138c-.3-.8-.54-1.42-.71-1.86S308.28,135.51,308.28,135.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,126.56c-.36,4-4.9,11.8-6.32,14,0,0-2.93-5.83-4.47-9L274,136.1c-1.23-1.12-.12-7.47-.31-7.41L278,117.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.34,117.88a3.73,3.73,0,0,1,.87-.16h0l0,0c1.16,1.23,3.84,4.22,7.37,8.22l.08.08,0,.12a38.2,38.2,0,0,1-4.12,10.8c-.74,1.32-1.52,2.57-2.32,3.74l-.27.39-.18-.43c-.94-2.26-2.12-4.27-3.08-6.16a25.63,25.63,0,0,1-2.17-5.29l.33,0c-.79,1.78-1.44,3.24-1.92,4.34a12.87,12.87,0,0,1-.77,1.55,12.8,12.8,0,0,1,.58-1.63c.45-1.11,1.06-2.6,1.79-4.41l.19-.48.15.51a26.59,26.59,0,0,0,2.22,5.17c1,1.87,2.18,3.87,3.15,6.17l-.45,0c.79-1.17,1.57-2.41,2.3-3.71a39.66,39.66,0,0,0,4.13-10.65l.05.2c-3.48-4.05-6.08-7.11-7.13-8.42l.06,0A5.47,5.47,0,0,1,277.34,117.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.89,146.34a43.68,43.68,0,0,1,1.13,6.13c.25,1.7.47,3.24.57,4.37a10,10,0,0,1,.06,1.34.85.85,0,0,1-.07.39c-.06.09-.15,0-.14,0s0,0,0,0c.14.23,0-.57-.2-1.64s-.47-2.64-.73-4.35A33,33,0,0,1,293.89,146.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.85,135.45h0a12.35,12.35,0,0,1-12.59-12.94c.12-2.36.21-4.08.21-4.08s-9.89-1.28-10.26-11.13.77-32.5.77-32.5h0a34.23,34.23,0,0,1,34.5,3.45L279,79.34l-1.63,38.54s-4.34,14.38-7.65,16.47C267.85,135.51,267.17,135.4,264.85,135.45Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.47,118.43a23.79,23.79,0,0,0,12.73-4.11s-3,7.15-12.81,6.52Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,89.57c.16-.07,6.71-2.17,6.67,4.57s-6.8,5.3-6.81,5.11S278,89.57,278,89.57Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,96.71s.12.08.32.18a1.15,1.15,0,0,0,.87,0,2.89,2.89,0,0,0,1.36-2.6,3.79,3.79,0,0,0-.31-1.68,1.37,1.37,0,0,0-.88-.91.59.59,0,0,0-.69.32c-.1.19-.05.32-.09.33s-.14-.11-.09-.39a.77.77,0,0,1,.27-.42.93.93,0,0,1,.65-.17,1.65,1.65,0,0,1,1.22,1.06,3.94,3.94,0,0,1,.39,1.88,3,3,0,0,1-1.73,2.9,1.26,1.26,0,0,1-1.07-.19C280,96.87,279.93,96.72,280,96.71Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.77,90.5a1.41,1.41,0,0,0,1.4,1.38,1.33,1.33,0,0,0,1.41-1.3,1.41,1.41,0,0,0-1.39-1.39A1.35,1.35,0,0,0,246.77,90.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,88.61c.18.17,1.23-.64,2.74-.68s2.64.7,2.8.51-.11-.41-.6-.75a3.81,3.81,0,0,0-2.25-.63,3.69,3.69,0,0,0-2.17.76C245.25,88.19,245.1,88.53,245.19,88.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.49,90.5a1.41,1.41,0,0,0,1.4,1.38,1.33,1.33,0,0,0,1.41-1.3,1.4,1.4,0,0,0-1.39-1.39A1.35,1.35,0,0,0,261.49,90.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.08,88.51c.18.18,1.22-.63,2.74-.67s2.64.7,2.8.51-.11-.41-.6-.75a3.86,3.86,0,0,0-2.25-.63,3.66,3.66,0,0,0-2.18.76C260.14,88.1,260,88.43,260.08,88.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.87,99.88a9.78,9.78,0,0,0-2.47-.39c-.39,0-.76-.09-.83-.36A1.93,1.93,0,0,1,251.8,98c.34-.94.69-1.93,1.07-3,1.48-4.23,2.54-7.7,2.37-7.76s-1.51,3.32-3,7.55c-.36,1-.7,2-1,3a2.16,2.16,0,0,0-.16,1.52,1,1,0,0,0,.65.55,2.73,2.73,0,0,0,.65.08A10.56,10.56,0,0,0,254.87,99.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.44,84.92c.19.39,1.67,0,3.46.1s3.27.39,3.47,0c.08-.18-.2-.54-.81-.89a6,6,0,0,0-5.28-.08C259.65,84.37,259.36,84.73,259.44,84.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,85.7c.28.36,1.49.08,2.91.16s2.61.41,2.91.07c.14-.16,0-.52-.53-.88a4.46,4.46,0,0,0-2.33-.72,4.38,4.38,0,0,0-2.37.53C244.87,85.18,244.68,85.52,244.8,85.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.09,103.08a2.23,2.23,0,0,0-1.46-.56,5.22,5.22,0,0,0-1.57.21,2.5,2.5,0,0,0-1.57.9,1.73,1.73,0,0,0-.19,1.22c.07.42.14,1.91,1,2.28h3.54a4.41,4.41,0,0,0,.85-2.17A2.08,2.08,0,0,0,259.09,103.08Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,107.15s.17,0,.41,0a1,1,0,0,0,.7-.66,6.68,6.68,0,0,0,.21-1.64,2.37,2.37,0,0,0-.51-1.78c-.43-.5-1.12-.33-1.76-.22a7.09,7.09,0,0,0-1.62.4c-.87.38-1,1.05-1.11,1s0-.17.09-.44a1.89,1.89,0,0,1,.85-.88,6.1,6.1,0,0,1,1.69-.55,4.82,4.82,0,0,1,1.06-.16,1.56,1.56,0,0,1,1.17.48,2.71,2.71,0,0,1,.62,2.17,5.73,5.73,0,0,1-.35,1.76,1.16,1.16,0,0,1-1,.72C258.06,107.33,257.94,107.16,258,107.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.59,81.15a5.62,5.62,0,0,0-.15,3.14,1.92,1.92,0,0,0,2.49,1.28,7.92,7.92,0,0,0-.37,3.16A4.29,4.29,0,0,0,274,91.52a2.92,2.92,0,0,0,3,.49,2.24,2.24,0,0,0,1.22-2.65A2,2,0,0,0,281,88.5a3.1,3.1,0,0,0-.49-3.12,2.07,2.07,0,0,0,2-1.77,4,4,0,0,0-.76-2.78c-.54-.83-1.23-1.54-1.79-2.34s-1-1.54-1.78-1.77a3,3,0,0,0-2,.38,32.59,32.59,0,0,0-5.92,3.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,74.86s4.6.54,5.24-2.54c1.67-8.08-9.45-11.51-9.45-11.51s-3.9-1-10.27-3.38A40.21,40.21,0,0,1,259.75,54a6.34,6.34,0,0,0-6.73.06,52,52,0,0,1-11.78,5.8s-4.36,1.14-4.34,6.8c0,2.61,4.44,4.55,4.44,4.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61,79.33l.75-4.72s-26.1-9.41-39.51-3.35V76.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.87,80.09s3.24,2.62,10.34,3c12.91.65,33.94-3.83,33.94-3.83l-37.3-2.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.28,63.61c.23-.14-.13,5.86-.13,5.86s-.62,3.76-5.34,3.53a4.53,4.53,0,0,1-4.6-5l.27-4.41a4.13,4.13,0,0,0,4.78-1.93S256.48,65.21,259.28,63.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.48,79.52a5.51,5.51,0,0,1-1.11.25l-3,.51c-2.56.41-6.1,1-10,1.55s-7.5.93-10.09,1.09c-1.3.08-2.35.13-3.08.13A4.34,4.34,0,0,1,252,83a5.32,5.32,0,0,1,1.12-.16l3.06-.3c2.58-.25,6.13-.68,10.05-1.24s7.47-1.07,10.05-1.39c1.29-.17,2.33-.29,3.06-.35A4.24,4.24,0,0,1,280.48,79.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.17 105.9 254.17 112.73 258.01 112.73 258.01 105.96 254.17 105.9",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,108.81s-.81.68-.67,2.76,2.21,3.88,2.21,3.88v1.76l-6.55-7.36s-.63-1-1.58-.72a2.76,2.76,0,0,0-1.58,4.29,2.57,2.57,0,0,0-1.67,2.75s-2.66-.86-2.66,2.21v1.85a1.43,1.43,0,0,0-1.81,0c-.86.77-.68,3-.41,4s7.64,11.34,9.94,12.42a15.19,15.19,0,0,1,3.75,2.48l5.05,6.1,9.33-8.75s-5.67-5.65-6-6.74.72-4.47.63-5.78a72.37,72.37,0,0,0-1-7.36C265.57,115.58,258.93,108.81,258.93,108.81Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,145.25a2.65,2.65,0,0,1-.36-.38l-1-1.16-3.79-4.47h0a14.84,14.84,0,0,0-1.91-1.43c-.36-.23-.74-.45-1.13-.66a9.22,9.22,0,0,1-1.24-.69,31.52,31.52,0,0,1-4.27-4.62c-1.4-1.77-2.85-3.71-4.28-5.84a9.66,9.66,0,0,1-1-1.75,7.66,7.66,0,0,1-.22-2,3.22,3.22,0,0,1,.61-2.08,1.51,1.51,0,0,1,1.08-.5,1.91,1.91,0,0,1,1.13.39l-.4.19v-1.46a5.05,5.05,0,0,1,.16-1.56,1.92,1.92,0,0,1,1.13-1.25,2.74,2.74,0,0,1,1.7,0l-.33.25a3.53,3.53,0,0,1,.38-1.77,2.61,2.61,0,0,1,1.48-1.24l-.16.37a4,4,0,0,1-.55-1.78,2.65,2.65,0,0,1,.67-1.82,3.75,3.75,0,0,1,1.63-1.07,1.42,1.42,0,0,1,1.09.12,2.19,2.19,0,0,1,.76.72l0,0,.16.19c2.19,2.45,4.32,4.85,6.38,7.17l-.45.17c0-.59,0-1.18,0-1.76l.08.19a7.43,7.43,0,0,1-2.15-3.26,5.27,5.27,0,0,1-.12-1.93,3,3,0,0,1,.75-1.82l.15-.17.18.18c1.67,1.73,3.26,3.4,4.74,5a27.41,27.41,0,0,1,2.07,2.52,2.3,2.3,0,0,1,.28.81c.05.25.09.51.14.77l.21,1.49c.13,1,.25,2,.34,2.87.05.47.09.92.14,1.37a5.16,5.16,0,0,1,0,1.36,26.51,26.51,0,0,0-.66,4.67,2.36,2.36,0,0,0,.47.86c.2.27.41.52.62.77.41.49.81.95,1.19,1.37l1.95,2.12L271.8,136a3.53,3.53,0,0,1,.41.47,3.53,3.53,0,0,1-.47-.41l-1.28-1.26c-.55-.56-1.23-1.25-2-2.08-.39-.41-.8-.86-1.22-1.35-.21-.25-.43-.5-.64-.77a2.51,2.51,0,0,1-.54-1c-.13-1.53.39-3.06.59-4.76a10.9,10.9,0,0,0-.14-2.64c-.1-.93-.22-1.88-.36-2.86-.08-.49-.15-1-.23-1.49,0-.24-.09-.49-.14-.75a1.61,1.61,0,0,0-.23-.66,26.2,26.2,0,0,0-2-2.45c-1.48-1.63-3.08-3.3-4.75-5l.33,0a2.7,2.7,0,0,0-.57,1.5,4.9,4.9,0,0,0,.11,1.75,6.91,6.91,0,0,0,2,3l.08.08v.11c0,.58,0,1.17,0,1.76v.67l-.45-.5-6.38-7.17-.17-.19h0l0,0a1.16,1.16,0,0,0-1.26-.61,3.24,3.24,0,0,0-1.39.91,2.11,2.11,0,0,0-.54,1.47,3.6,3.6,0,0,0,.48,1.54l.14.28-.3.1a2.12,2.12,0,0,0-1.16,1,3,3,0,0,0-.32,1.51v.34l-.34-.1a2.25,2.25,0,0,0-1.36,0,1.42,1.42,0,0,0-.83.94,4.89,4.89,0,0,0-.15,1.4v2l-.4-.31a1.12,1.12,0,0,0-1.55,0,2.83,2.83,0,0,0-.49,1.76,7.61,7.61,0,0,0,.2,1.91,10.63,10.63,0,0,0,.92,1.61c1.4,2.12,2.84,4.07,4.22,5.84a31.54,31.54,0,0,0,4.16,4.59,6.65,6.65,0,0,0,.56.36l.62.32c.4.22.79.45,1.15.69a14.44,14.44,0,0,1,1.93,1.49h0l3.69,4.55,1,1.2A2.67,2.67,0,0,1,263,145.25Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,119.12a14.05,14.05,0,0,1-2.6-2.83,14,14,0,0,1-2.19-3.16,14.63,14.63,0,0,1,2.6,2.84A14.47,14.47,0,0,1,255.41,119.12Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.91,120.46c-.1.1-1-.69-1.75-1.94a4.66,4.66,0,0,1-.93-2.44c.14-.06.64,1,1.37,2.17A11.46,11.46,0,0,1,251.91,120.46Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.72,123.07c-.13.07-.58-.53-1-1.34s-.67-1.51-.54-1.58.57.53,1,1.34S247.84,123,247.72,123.07Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.84,
    y: 166.62,
    width: 17.92,
    height: 3.89,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,224.73s.63,14.21,32.47,13.12,44.65-13.12,44.65-13.12v14.91s-34.53,13.72-58.38,10.28c-18.74-2.71-23-10.28-23-10.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,258.61h0a4.84,4.84,0,0,1-4.84-4.84V233.63a4.84,4.84,0,0,1,4.84-4.84h0a4.84,4.84,0,0,1,4.84,4.84v20.14A4.84,4.84,0,0,1,246.58,258.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.58,258.61a6.29,6.29,0,0,1,.71-.11,5,5,0,0,0,1.86-.75,4.78,4.78,0,0,0,1.88-2.49,5.35,5.35,0,0,0,.22-2c0-.72,0-1.48,0-2.28,0-3.21,0-7,0-11.23,0-2.1,0-4.36,0-6.61a4.58,4.58,0,0,0-9.12,0c-.05,2.25,0,4.51,0,6.61,0,4.21,0,8-.06,11.23,0,.8,0,1.56,0,2.28a5.35,5.35,0,0,0,.22,2,4.74,4.74,0,0,0,1.88,2.49,5,5,0,0,0,1.86.75,6.29,6.29,0,0,1,.71.11,2.47,2.47,0,0,1-.72,0,4.65,4.65,0,0,1-2-.68,4.87,4.87,0,0,1-2-2.57,5.72,5.72,0,0,1-.29-2c0-.72,0-1.48,0-2.28,0-3.21,0-7-.06-11.23,0-2.13,0-4.31,0-6.66a5.1,5.1,0,0,1,5.07-4.6A5.09,5.09,0,0,1,250,229.9a5.14,5.14,0,0,1,1.61,3.23c0,2.35,0,4.53,0,6.66,0,4.21,0,8-.06,11.23,0,.8,0,1.56,0,2.28a5.51,5.51,0,0,1-.28,2,4.92,4.92,0,0,1-2,2.57,4.65,4.65,0,0,1-2,.68A2.47,2.47,0,0,1,246.58,258.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,236.37a1.39,1.39,0,0,0-1.15,1.14,1.21,1.21,0,0,0,.89,1.3,1.32,1.32,0,0,0,1.44-.95,1.25,1.25,0,0,0-1.18-1.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,236.37s.12-.06.32,0a1.17,1.17,0,0,1,.78.42,1.52,1.52,0,0,1,.28,1.32,1.6,1.6,0,0,1-1.32,1,1.33,1.33,0,0,1-1.37-.94,1.37,1.37,0,0,1,.25-1.32c.53-.59,1.08-.5,1.06-.45s-.43.16-.76.67a1,1,0,0,0-.1.93.89.89,0,0,0,.87.6,1.2,1.2,0,0,0,.91-.65,1.23,1.23,0,0,0-.12-.95C247,236.49,246.53,236.47,246.56,236.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,248.3a1.39,1.39,0,0,0-1.16,1.14,1.21,1.21,0,0,0,.89,1.3,1.33,1.33,0,0,0,1.45-1,1.26,1.26,0,0,0-1.18-1.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.59,248.3s.11-.06.31,0a1.17,1.17,0,0,1,.78.42A1.52,1.52,0,0,1,248,250a1.59,1.59,0,0,1-1.32,1,1.32,1.32,0,0,1-1.36-.94,1.37,1.37,0,0,1,.24-1.32c.54-.59,1.09-.5,1.07-.45s-.44.16-.77.67a1,1,0,0,0-.09.93.89.89,0,0,0,.86.6,1.19,1.19,0,0,0,.91-.65,1.23,1.23,0,0,0-.12-.95C247.06,248.41,246.55,248.4,246.59,248.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,257.64h0a4.84,4.84,0,0,1-4.84-4.84V232.67a4.84,4.84,0,0,1,4.84-4.84h0a4.84,4.84,0,0,1,4.84,4.84V252.8A4.84,4.84,0,0,1,234,257.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,257.64s.25,0,.71-.11a4.8,4.8,0,0,0,1.86-.75,4.74,4.74,0,0,0,1.88-2.49,5.35,5.35,0,0,0,.22-2c0-.72,0-1.48,0-2.28,0-3.21,0-7,0-11.23,0-2.1,0-4.36,0-6.61a4.58,4.58,0,0,0-9.12,0c-.05,2.25,0,4.51,0,6.61,0,4.22,0,8-.06,11.23,0,.8,0,1.56,0,2.28a5.35,5.35,0,0,0,.22,2,4.74,4.74,0,0,0,1.88,2.49,4.8,4.8,0,0,0,1.86.75c.46.09.71.09.71.11a2.64,2.64,0,0,1-.72,0,4.7,4.7,0,0,1-2-.69,4.85,4.85,0,0,1-2-2.56,5.75,5.75,0,0,1-.29-2.06c0-.72,0-1.48,0-2.28,0-3.21,0-7-.06-11.23,0-2.12,0-4.31,0-6.66a5.14,5.14,0,0,1,1.61-3.23,5.08,5.08,0,0,1,6.92,0,5.14,5.14,0,0,1,1.61,3.23c.05,2.35,0,4.54,0,6.66,0,4.21,0,8-.06,11.23,0,.8,0,1.56,0,2.28a5.53,5.53,0,0,1-.28,2.06,4.89,4.89,0,0,1-2,2.56,4.7,4.7,0,0,1-2,.69A2.64,2.64,0,0,1,234,257.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,236.37a1.39,1.39,0,0,0-1.15,1.14,1.21,1.21,0,0,0,.89,1.3,1.32,1.32,0,0,0,1.44-.95,1.25,1.25,0,0,0-1.18-1.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,236.37s.12-.06.32,0a1.17,1.17,0,0,1,.78.42,1.52,1.52,0,0,1,.28,1.32,1.6,1.6,0,0,1-1.32,1,1.33,1.33,0,0,1-1.37-.94,1.37,1.37,0,0,1,.25-1.32c.53-.59,1.08-.5,1.06-.45s-.43.16-.76.67a1,1,0,0,0-.1.93.89.89,0,0,0,.87.6,1.2,1.2,0,0,0,.91-.65,1.23,1.23,0,0,0-.12-.95C234.45,236.49,233.94,236.47,234,236.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,241.83a10.19,10.19,0,0,0,10,.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.94,242.59a3.31,3.31,0,0,1-1.38.72,9.43,9.43,0,0,1-7.36-.56c-.85-.46-1.29-.87-1.25-.92a16.15,16.15,0,0,0,4.91,1.43A15.79,15.79,0,0,0,238.94,242.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,247.86h0a4.84,4.84,0,0,1-4.84-4.84V222.88A4.84,4.84,0,0,1,302,218h0a4.84,4.84,0,0,1,4.84,4.84V243A4.84,4.84,0,0,1,302,247.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,247.86a6.31,6.31,0,0,1,.7-.11,4.94,4.94,0,0,0,1.87-.75,4.76,4.76,0,0,0,1.87-2.49,5.34,5.34,0,0,0,.23-2c0-.72,0-1.48,0-2.28,0-3.22,0-7-.05-11.23,0-2.1,0-4.36,0-6.61a4.58,4.58,0,0,0-9.12,0c0,2.25,0,4.5,0,6.61,0,4.21,0,8-.06,11.23,0,.8,0,1.56,0,2.28a5.56,5.56,0,0,0,.23,2,4.78,4.78,0,0,0,1.88,2.49,4.91,4.91,0,0,0,1.86.75,6.29,6.29,0,0,1,.71.11,2.53,2.53,0,0,1-.73,0,4.62,4.62,0,0,1-2-.68,4.93,4.93,0,0,1-2-2.57,6,6,0,0,1-.28-2c0-.72,0-1.48,0-2.28,0-3.21,0-7-.05-11.23,0-2.13,0-4.31,0-6.66a5.1,5.1,0,0,1,10.14,0c0,2.35,0,4.53,0,6.66,0,4.21,0,8-.06,11.23,0,.8,0,1.56,0,2.28a5.51,5.51,0,0,1-.28,2,4.92,4.92,0,0,1-2,2.57,4.65,4.65,0,0,1-2,.68A2.47,2.47,0,0,1,302,247.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,225.62a1.37,1.37,0,0,0-1.15,1.14,1.2,1.2,0,0,0,.89,1.3,1.33,1.33,0,0,0,1.44-.95,1.25,1.25,0,0,0-1.18-1.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,225.62s.11-.06.32,0a1.21,1.21,0,0,1,.78.42,1.51,1.51,0,0,1,.27,1.32,1.57,1.57,0,0,1-1.31,1,1.33,1.33,0,0,1-1.37-.94,1.34,1.34,0,0,1,.25-1.32c.53-.59,1.08-.5,1.06-.45s-.43.16-.76.67a1,1,0,0,0-.1.93.89.89,0,0,0,.86.6,1.2,1.2,0,0,0,.92-.65,1.23,1.23,0,0,0-.12-.95C302.47,225.73,302,225.72,302,225.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,237.55a1.38,1.38,0,0,0-1.15,1.13,1.22,1.22,0,0,0,.89,1.31,1.32,1.32,0,0,0,1.44-1,1.24,1.24,0,0,0-1.18-1.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,237.55s.12-.06.32,0a1.17,1.17,0,0,1,.78.42,1.51,1.51,0,0,1,.28,1.32,1.6,1.6,0,0,1-1.32,1,1.33,1.33,0,0,1-1.37-.94A1.37,1.37,0,0,1,301,238c.53-.59,1.08-.5,1.06-.45s-.43.16-.76.67a1,1,0,0,0-.1.93.89.89,0,0,0,.87.6,1.2,1.2,0,0,0,.91-.65,1.23,1.23,0,0,0-.12-.95C302.5,237.66,302,237.65,302,237.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,252.51h0a4.84,4.84,0,0,1-4.84-4.84V227.53A4.84,4.84,0,0,1,289,222.7h0a4.83,4.83,0,0,1,4.84,4.83v20.14A4.83,4.83,0,0,1,289,252.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,252.51s.25,0,.71-.11a5,5,0,0,0,1.86-.75,4.74,4.74,0,0,0,1.88-2.49,5.56,5.56,0,0,0,.23-2c0-.72,0-1.48,0-2.28,0-3.21,0-7-.06-11.23,0-2.1,0-4.36,0-6.61A4.59,4.59,0,0,0,289,223a4.53,4.53,0,0,0-3.1,1.22,4.61,4.61,0,0,0-1.46,2.9c-.05,2.25,0,4.51,0,6.61,0,4.21,0,8-.05,11.23,0,.8,0,1.56,0,2.28a5.35,5.35,0,0,0,.22,2,4.74,4.74,0,0,0,1.88,2.49,4.94,4.94,0,0,0,1.87.75c.45.09.7.08.7.11a2.64,2.64,0,0,1-.72,0,4.7,4.7,0,0,1-2-.69,4.89,4.89,0,0,1-2-2.56,5.53,5.53,0,0,1-.28-2.06c0-.72,0-1.48,0-2.28,0-3.21,0-7-.06-11.23,0-2.12,0-4.31,0-6.66a5.12,5.12,0,0,1,5.07-4.6,5.09,5.09,0,0,1,3.46,1.37A5.14,5.14,0,0,1,294,227c.05,2.35,0,4.54,0,6.66,0,4.21,0,8,0,11.23,0,.8,0,1.56,0,2.28a6,6,0,0,1-.28,2.06,5,5,0,0,1-2.05,2.56,4.7,4.7,0,0,1-2,.69A2.64,2.64,0,0,1,289,252.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,231.24a1.38,1.38,0,0,0-1.16,1.14,1.21,1.21,0,0,0,.89,1.3,1.33,1.33,0,0,0,1.45-1,1.26,1.26,0,0,0-1.18-1.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,231.24s.11-.06.31,0a1.17,1.17,0,0,1,.78.42,1.51,1.51,0,0,1,.28,1.32,1.59,1.59,0,0,1-1.32,1,1.32,1.32,0,0,1-1.36-.94,1.37,1.37,0,0,1,.24-1.32c.54-.59,1.09-.5,1.07-.45s-.44.16-.77.67a1,1,0,0,0-.09.93.89.89,0,0,0,.86.6,1.19,1.19,0,0,0,.91-.65,1.23,1.23,0,0,0-.12-.95C289.41,231.35,288.9,231.34,288.94,231.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.91,236.7a10.19,10.19,0,0,0,10,.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.9,237.46a3.22,3.22,0,0,1-1.38.72,9.44,9.44,0,0,1-7.36-.56c-.85-.46-1.29-.87-1.25-.92a16.4,16.4,0,0,0,4.92,1.43A16.09,16.09,0,0,0,293.9,237.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.91,264.1h0A5,5,0,0,1,217,259l.56-36.58a5,5,0,0,1,5.1-4.94h0a5,5,0,0,1,4.94,5.1L227,259.16A5,5,0,0,1,221.91,264.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.91,264.1s.37,0,1-.15a5,5,0,0,0,2.57-1.46,4.91,4.91,0,0,0,1.1-1.84,7.6,7.6,0,0,0,.25-2.55c0-1.89,0-4,.06-6.39.06-4.75.13-10.39.21-16.64,0-3.13.09-6.42.13-9.83,0-.85,0-1.71,0-2.57a4.88,4.88,0,0,0-.56-2.4,4.75,4.75,0,0,0-8.33-.13,4.84,4.84,0,0,0-.63,2.38c0,.86,0,1.72,0,2.57-.06,3.41-.12,6.7-.17,9.83-.12,6.25-.23,11.89-.32,16.64,0,2.36-.09,4.5-.13,6.39a7.79,7.79,0,0,0,.17,2.56,5.11,5.11,0,0,0,1,1.87,5,5,0,0,0,2.52,1.54c.68.16,1,.15,1,.18a3.77,3.77,0,0,1-1.07-.08,5,5,0,0,1-2.65-1.51,5,5,0,0,1-1.12-1.93,7.82,7.82,0,0,1-.23-2.64c0-1.88,0-4,.06-6.39,0-4.75.12-10.38.2-16.64,0-3.13.09-6.42.14-9.82l0-2.58a5.45,5.45,0,0,1,.7-2.63,5.27,5.27,0,0,1,9.24.15,5.43,5.43,0,0,1,.62,2.64c0,.87,0,1.73-.05,2.58q-.09,5.12-.16,9.83c-.12,6.25-.23,11.88-.32,16.63-.05,2.37-.09,4.51-.14,6.39a7.7,7.7,0,0,1-.31,2.63,5.13,5.13,0,0,1-1.18,1.9,5.05,5.05,0,0,1-2.7,1.43A3.88,3.88,0,0,1,221.91,264.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.32,237.15l.88,13.5a1.67,1.67,0,0,0,1.77,1.56l9.4-.61a1.68,1.68,0,0,0,1.56-1.78l-.88-13.5a1.67,1.67,0,0,0-1.77-1.56l-9.41.62A1.67,1.67,0,0,0,258.32,237.15Zm10.12,12.73-6,.39a1.66,1.66,0,0,1-1.77-1.55l-.62-9.5a1.67,1.67,0,0,1,1.56-1.77l6-.39a1.67,1.67,0,0,1,1.77,1.56l.62,9.49A1.67,1.67,0,0,1,268.44,249.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.24,241.77a16.19,16.19,0,0,0-4.6-.69,15.86,15.86,0,0,0-4.5,1.15s.37-.42,1.16-.82a8.44,8.44,0,0,1,3.32-.85,8.71,8.71,0,0,1,3.38.51C273.83,241.39,274.27,241.72,274.24,241.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.51,245.29a10.18,10.18,0,0,0-8.79.64s.33-.44,1.07-.87a7.69,7.69,0,0,1,6.53-.48C274.12,244.9,274.54,245.24,274.51,245.29Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-403--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.83,
    y: 58.62,
    width: 207.59,
    height: 207.59,
    transform: "translate(-12.8 49.32) rotate(-5.32)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.6,256.15s0-.33-.11-1-.16-1.6-.28-2.86c-.24-2.52-.6-6.24-1.07-11.09-.92-9.7-2.27-23.92-4-42-3.4-36.16-8.26-87.79-14.09-149.73l.32.26L411.71,69h0l.3-.36,19.2,206.7-.32-.26,149.77-13.79,42-3.84,11.1-1,2.85-.25,1-.07-.94.1-2.82.28-11,1.06-42,4L430.93,275.68l-.29,0,0-.29c-5.6-60.08-12.22-131-19.28-206.7l0-.33.33,0h0l206.68-19.2.29,0,0,.29c5.71,62,10.47,113.74,13.81,150,1.65,18.07,2.94,32.27,3.83,42,.43,4.83.77,8.53,1,11,.11,1.24.19,2.18.25,2.82S637.6,256.15,637.6,256.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.71,
    y: 54.97,
    width: 9.11,
    height: 22.12,
    transform: "translate(-4.28 39.8) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.97,
    y: 261.82,
    width: 9.11,
    height: 22.12,
    transform: "translate(-23.37 42.46) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.74,
    y: 38.12,
    width: 9.11,
    height: 22.12,
    transform: "translate(-1.94 56.49) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.12,
    y: 246.37,
    width: 9.11,
    height: 22.12,
    transform: "translate(-21.16 59.2) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.83,
    cy: 121.58,
    r: 45.4,
    transform: "translate(99.74 451.32) rotate(-51.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.79,167.63a46,46,0,1,1,45.89-50.32h0a46.11,46.11,0,0,1-41.58,50.12C523.65,167.56,522.22,167.63,520.79,167.63Zm.07-90.82c-1.38,0-2.78.07-4.18.2a44.68,44.68,0,1,0,4.18-.2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.93,116.35a3.19,3.19,0,0,0-5.13-.26,11.06,11.06,0,0,0-1.4,3.13c-.89,2.75-1.67,5.53-2.54,8.29-.09.29-.44.51-.67.76-.19-.28-.5-.55-.54-.86-.22-1.57-.4-3.15-.54-4.73-.29-3.11-.54-6.22-.82-9.32-.48-5.22-1-10.45-1.49-15.66a3.22,3.22,0,0,0-.69-1.62,3.06,3.06,0,0,0-3.53-.63,2.89,2.89,0,0,0-1.56,3q.76,8.31,1.54,16.61a2.32,2.32,0,0,1,0,.78c-.07.21-.31.48-.5.5a.81.81,0,0,1-.57-.4,2.09,2.09,0,0,1-.12-.76l-1.8-19.3a10,10,0,0,0-.14-1.21,2.25,2.25,0,0,0-2-1.94,3,3,0,0,0-3.73,3.46q.87,9.51,1.77,19a5.31,5.31,0,0,1,0,1.12.71.71,0,0,1-.45.5.74.74,0,0,1-.58-.36,3.45,3.45,0,0,1-.16-1c-.48-5.08-.93-10.15-1.43-15.23a2.92,2.92,0,0,0-5.81.56q.74,8.1,1.5,16.18a3.45,3.45,0,0,1,.06,1,3.34,3.34,0,0,1-.47.81c-.23-.24-.64-.46-.67-.72-.22-1.95-.36-3.92-.54-5.88s-.36-4.16-.59-6.23a2.74,2.74,0,0,0-3.25-2.39,2.53,2.53,0,0,0-2.34,2.88q.4,6.1.79,12.22h0c.23,2.48.43,5,.55,7.45a37.64,37.64,0,0,0,3.28,14.37,13.36,13.36,0,0,0,10,7.89,19.33,19.33,0,0,0,14.12-2.84,13,13,0,0,0,6-7.73c1.65-6.29,3.17-12.61,4.67-18.93A3.65,3.65,0,0,0,541.93,116.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,235.61l.13,1.47-8.61.8L467.45,226l8.38-.78.14,1.47-6.68.63.33,3.64,6-.55.13,1.44-5.95.56.36,3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.67,227.32l.15,1.58-.38,0c-1.74.16-2.73,1.33-2.55,3.3l.42,4.48-1.63.15-.84-9,1.57-.15.14,1.51A3.44,3.44,0,0,1,483.67,227.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.5,226.69l.15,1.57-.37,0c-1.75.17-2.74,1.34-2.55,3.3l.41,4.48-1.63.15-.83-9,1.56-.14.14,1.51A3.43,3.43,0,0,1,490.5,226.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,231.17a4.7,4.7,0,1,1,5.11,4.16A4.5,4.5,0,0,1,492,231.17Zm7.71-.72A3,3,0,1,0,497,233.9,3,3,0,0,0,499.72,230.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508,225.06l.15,1.57-.38,0c-1.74.16-2.73,1.33-2.55,3.3l.42,4.48-1.63.15-.83-9,1.56-.14.14,1.51A3.41,3.41,0,0,1,508,225.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.51,222.93l.39,4.14,6-.55L523,228l-6,.56.45,4.8-1.7.16-1.1-11.88,8.38-.78.14,1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.78,228.12a4.69,4.69,0,1,1,5.11,4.16A4.49,4.49,0,0,1,524.78,228.12Zm7.7-.72a3,3,0,1,0-2.73,3.45A3,3,0,0,0,532.48,227.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.78,222l.15,1.57-.38,0c-1.74.16-2.73,1.33-2.55,3.3l.42,4.48-1.63.15-.83-9,1.56-.14.14,1.51A3.43,3.43,0,0,1,540.78,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.52,225.53a4.39,4.39,0,0,1-4.12,5,3.8,3.8,0,0,1-3.35-1.22l.14,1.42-1.57.15-1.17-12.59,1.63-.15.46,5a3.85,3.85,0,0,1,3-1.73A4.38,4.38,0,0,1,552.52,225.53Zm-1.65.16a3,3,0,1,0-2.74,3.45A3,3,0,0,0,550.87,225.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.81,218.07a1.07,1.07,0,0,1,1-1.17,1.06,1.06,0,0,1,1.2.93,1.07,1.07,0,0,1-1,1.19A1.05,1.05,0,0,1,553.81,218.07Zm.54,2.76,1.63-.15.84,9-1.63.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.23,216l1.17,12.59-1.56.14-.13-1.42a3.82,3.82,0,0,1-3.06,1.83,4.61,4.61,0,0,1-.86-9.18,3.82,3.82,0,0,1,3.27,1.15l-.46-5Zm-.86,8.24a3,3,0,1,0-2.72,3.46A3,3,0,0,0,566.37,224.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.79,214.93,580,227.51l-1.56.15-.13-1.43a3.82,3.82,0,0,1-3.07,1.83,4.61,4.61,0,0,1-.85-9.18,3.83,3.83,0,0,1,3.27,1.15l-.46-4.95Zm-.85,8.24a3,3,0,1,0-2.73,3.45A3,3,0,0,0,577.94,223.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.77,222.52l-7.29.68a3,3,0,0,0,3.5,2.32,3.37,3.37,0,0,0,2.5-1.32l1,1a4.92,4.92,0,0,1-8.67-2.36,4.42,4.42,0,0,1,4.09-5,4.35,4.35,0,0,1,4.87,4.21A2.77,2.77,0,0,1,590.77,222.52Zm-7.4-.49,5.77-.54a2.92,2.92,0,0,0-5.77.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.48,220.29l.48,5.17-1.63.16-.46-5c-.17-1.76-1.13-2.55-2.67-2.4a2.68,2.68,0,0,0-2.57,3.25l.43,4.63-1.63.15-.84-9,1.56-.15.13,1.36a3.86,3.86,0,0,1,3.11-1.74C599.57,216.53,601.23,217.65,601.48,220.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.2,206.21l-6.69.62.8,8.59-6.81.64-.8-8.59L474,209.4l-.46-4.87,16.37-26.09,7.51-.7L482,202.66l12.37-1.16-.71-7.61,6.59-.62.71,7.62,6.7-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.21,195.61c-1.15-12.42,5-20.08,14-20.91s16.48,5.55,17.64,18-5,20.08-14,20.92S511.37,208,510.21,195.61Zm24.53-2.28c-.85-9.13-4.81-13-10-12.53s-8.31,5-7.46,14.16,4.81,13,9.94,12.53S535.59,202.46,534.74,193.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.58,197.34c.59,6.38-3.7,12.34-13.86,13.28-5.34.5-10.84-.62-14.61-3.05l2.52-5.74a17.73,17.73,0,0,0,11.42,2.7c5-.47,7.79-3,7.46-6.47s-3-5.39-8.73-4.86l-3.46.32-.45-4.8,7.64-11-17.18,1.6-.55-5.89,25.77-2.4.44,4.7-8.17,11.77C569,187.74,573.05,191.67,573.58,197.34Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403ErrorOption);
export default __webpack_public_path__ + "static/media/403-error-option.ae9fad28bc80b5d5e762fbb3c4390984.svg";
export { ForwardRef as ReactComponent };